import "../../index94.css";
import { jsx as ti } from "react/jsx-runtime";
import ui from "react";
import { a as ri, i as ii } from "../../core-DVmjA3_O.js";
import { _ as ni } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import { c as O, a as ai, g as si } from "../../_commonjsHelpers-BkfeUUK-.js";
var $u = {}, De = {}, zt = {}, Pe = {}, Gt = {};
Object.defineProperty(Gt, "__esModule", { value: !0 });
Gt.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(r) {
    return r.charCodeAt(0);
  })
);
var Wt = {};
Object.defineProperty(Wt, "__esModule", { value: !0 });
Wt.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(r) {
    return r.charCodeAt(0);
  })
);
var Nt = {};
(function(r) {
  var e;
  Object.defineProperty(r, "__esModule", { value: !0 }), r.replaceCodePoint = r.fromCodePoint = void 0;
  var t = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  r.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (e = String.fromCodePoint) !== null && e !== void 0 ? e : function(n) {
    var o = "";
    return n > 65535 && (n -= 65536, o += String.fromCharCode(n >>> 10 & 1023 | 55296), n = 56320 | n & 1023), o += String.fromCharCode(n), o;
  };
  function u(n) {
    var o;
    return n >= 55296 && n <= 57343 || n > 1114111 ? 65533 : (o = t.get(n)) !== null && o !== void 0 ? o : n;
  }
  r.replaceCodePoint = u;
  function i(n) {
    return (0, r.fromCodePoint)(u(n));
  }
  r.default = i;
})(Nt);
(function(r) {
  var e = O && O.__createBinding || (Object.create ? function(p, x, v, A) {
    A === void 0 && (A = v);
    var h = Object.getOwnPropertyDescriptor(x, v);
    (!h || ("get" in h ? !x.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return x[v];
    } }), Object.defineProperty(p, A, h);
  } : function(p, x, v, A) {
    A === void 0 && (A = v), p[A] = x[v];
  }), t = O && O.__setModuleDefault || (Object.create ? function(p, x) {
    Object.defineProperty(p, "default", { enumerable: !0, value: x });
  } : function(p, x) {
    p.default = x;
  }), u = O && O.__importStar || function(p) {
    if (p && p.__esModule) return p;
    var x = {};
    if (p != null) for (var v in p) v !== "default" && Object.prototype.hasOwnProperty.call(p, v) && e(x, p, v);
    return t(x, p), x;
  }, i = O && O.__importDefault || function(p) {
    return p && p.__esModule ? p : { default: p };
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.decodeXML = r.decodeHTMLStrict = r.decodeHTMLAttribute = r.decodeHTML = r.determineBranch = r.EntityDecoder = r.DecodingMode = r.BinTrieFlags = r.fromCodePoint = r.replaceCodePoint = r.decodeCodePoint = r.xmlDecodeTree = r.htmlDecodeTree = void 0;
  var n = i(Gt);
  r.htmlDecodeTree = n.default;
  var o = i(Wt);
  r.xmlDecodeTree = o.default;
  var l = u(Nt);
  r.decodeCodePoint = l.default;
  var a = Nt;
  Object.defineProperty(r, "replaceCodePoint", { enumerable: !0, get: function() {
    return a.replaceCodePoint;
  } }), Object.defineProperty(r, "fromCodePoint", { enumerable: !0, get: function() {
    return a.fromCodePoint;
  } });
  var f;
  (function(p) {
    p[p.NUM = 35] = "NUM", p[p.SEMI = 59] = "SEMI", p[p.EQUALS = 61] = "EQUALS", p[p.ZERO = 48] = "ZERO", p[p.NINE = 57] = "NINE", p[p.LOWER_A = 97] = "LOWER_A", p[p.LOWER_F = 102] = "LOWER_F", p[p.LOWER_X = 120] = "LOWER_X", p[p.LOWER_Z = 122] = "LOWER_Z", p[p.UPPER_A = 65] = "UPPER_A", p[p.UPPER_F = 70] = "UPPER_F", p[p.UPPER_Z = 90] = "UPPER_Z";
  })(f || (f = {}));
  var d = 32, y;
  (function(p) {
    p[p.VALUE_LENGTH = 49152] = "VALUE_LENGTH", p[p.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", p[p.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(y = r.BinTrieFlags || (r.BinTrieFlags = {}));
  function s(p) {
    return p >= f.ZERO && p <= f.NINE;
  }
  function c(p) {
    return p >= f.UPPER_A && p <= f.UPPER_F || p >= f.LOWER_A && p <= f.LOWER_F;
  }
  function w(p) {
    return p >= f.UPPER_A && p <= f.UPPER_Z || p >= f.LOWER_A && p <= f.LOWER_Z || s(p);
  }
  function E(p) {
    return p === f.EQUALS || w(p);
  }
  var b;
  (function(p) {
    p[p.EntityStart = 0] = "EntityStart", p[p.NumericStart = 1] = "NumericStart", p[p.NumericDecimal = 2] = "NumericDecimal", p[p.NumericHex = 3] = "NumericHex", p[p.NamedEntity = 4] = "NamedEntity";
  })(b || (b = {}));
  var S;
  (function(p) {
    p[p.Legacy = 0] = "Legacy", p[p.Strict = 1] = "Strict", p[p.Attribute = 2] = "Attribute";
  })(S = r.DecodingMode || (r.DecodingMode = {}));
  var N = (
    /** @class */
    function() {
      function p(x, v, A) {
        this.decodeTree = x, this.emitCodePoint = v, this.errors = A, this.state = b.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = S.Strict;
      }
      return p.prototype.startEntity = function(x) {
        this.decodeMode = x, this.state = b.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, p.prototype.write = function(x, v) {
        switch (this.state) {
          case b.EntityStart:
            return x.charCodeAt(v) === f.NUM ? (this.state = b.NumericStart, this.consumed += 1, this.stateNumericStart(x, v + 1)) : (this.state = b.NamedEntity, this.stateNamedEntity(x, v));
          case b.NumericStart:
            return this.stateNumericStart(x, v);
          case b.NumericDecimal:
            return this.stateNumericDecimal(x, v);
          case b.NumericHex:
            return this.stateNumericHex(x, v);
          case b.NamedEntity:
            return this.stateNamedEntity(x, v);
        }
      }, p.prototype.stateNumericStart = function(x, v) {
        return v >= x.length ? -1 : (x.charCodeAt(v) | d) === f.LOWER_X ? (this.state = b.NumericHex, this.consumed += 1, this.stateNumericHex(x, v + 1)) : (this.state = b.NumericDecimal, this.stateNumericDecimal(x, v));
      }, p.prototype.addToNumericResult = function(x, v, A, h) {
        if (v !== A) {
          var g = A - v;
          this.result = this.result * Math.pow(h, g) + parseInt(x.substr(v, g), h), this.consumed += g;
        }
      }, p.prototype.stateNumericHex = function(x, v) {
        for (var A = v; v < x.length; ) {
          var h = x.charCodeAt(v);
          if (s(h) || c(h))
            v += 1;
          else
            return this.addToNumericResult(x, A, v, 16), this.emitNumericEntity(h, 3);
        }
        return this.addToNumericResult(x, A, v, 16), -1;
      }, p.prototype.stateNumericDecimal = function(x, v) {
        for (var A = v; v < x.length; ) {
          var h = x.charCodeAt(v);
          if (s(h))
            v += 1;
          else
            return this.addToNumericResult(x, A, v, 10), this.emitNumericEntity(h, 2);
        }
        return this.addToNumericResult(x, A, v, 10), -1;
      }, p.prototype.emitNumericEntity = function(x, v) {
        var A;
        if (this.consumed <= v)
          return (A = this.errors) === null || A === void 0 || A.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (x === f.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === S.Strict)
          return 0;
        return this.emitCodePoint((0, l.replaceCodePoint)(this.result), this.consumed), this.errors && (x !== f.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, p.prototype.stateNamedEntity = function(x, v) {
        for (var A = this.decodeTree, h = A[this.treeIndex], g = (h & y.VALUE_LENGTH) >> 14; v < x.length; v++, this.excess++) {
          var m = x.charCodeAt(v);
          if (this.treeIndex = I(A, h, this.treeIndex + Math.max(1, g), m), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === S.Attribute && // We shouldn't have consumed any characters after the entity,
            (g === 0 || // And there should be no invalid characters.
            E(m)) ? 0 : this.emitNotTerminatedNamedEntity();
          if (h = A[this.treeIndex], g = (h & y.VALUE_LENGTH) >> 14, g !== 0) {
            if (m === f.SEMI)
              return this.emitNamedEntityData(this.treeIndex, g, this.consumed + this.excess);
            this.decodeMode !== S.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, p.prototype.emitNotTerminatedNamedEntity = function() {
        var x, v = this, A = v.result, h = v.decodeTree, g = (h[A] & y.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(A, g, this.consumed), (x = this.errors) === null || x === void 0 || x.missingSemicolonAfterCharacterReference(), this.consumed;
      }, p.prototype.emitNamedEntityData = function(x, v, A) {
        var h = this.decodeTree;
        return this.emitCodePoint(v === 1 ? h[x] & ~y.VALUE_LENGTH : h[x + 1], A), v === 3 && this.emitCodePoint(h[x + 2], A), A;
      }, p.prototype.end = function() {
        var x;
        switch (this.state) {
          case b.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== S.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          case b.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case b.NumericHex:
            return this.emitNumericEntity(0, 3);
          case b.NumericStart:
            return (x = this.errors) === null || x === void 0 || x.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case b.EntityStart:
            return 0;
        }
      }, p;
    }()
  );
  r.EntityDecoder = N;
  function D(p) {
    var x = "", v = new N(p, function(A) {
      return x += (0, l.fromCodePoint)(A);
    });
    return function(h, g) {
      for (var m = 0, T = 0; (T = h.indexOf("&", T)) >= 0; ) {
        x += h.slice(m, T), v.startEntity(g);
        var j = v.write(
          h,
          // Skip the "&"
          T + 1
        );
        if (j < 0) {
          m = T + v.end();
          break;
        }
        m = T + j, T = j === 0 ? m + 1 : m;
      }
      var U = x + h.slice(m);
      return x = "", U;
    };
  }
  function I(p, x, v, A) {
    var h = (x & y.BRANCH_LENGTH) >> 7, g = x & y.JUMP_TABLE;
    if (h === 0)
      return g !== 0 && A === g ? v : -1;
    if (g) {
      var m = A - g;
      return m < 0 || m >= h ? -1 : p[v + m] - 1;
    }
    for (var T = v, j = T + h - 1; T <= j; ) {
      var U = T + j >>> 1, k = p[U];
      if (k < A)
        T = U + 1;
      else if (k > A)
        j = U - 1;
      else
        return p[U + h];
    }
    return -1;
  }
  r.determineBranch = I;
  var R = D(n.default), $ = D(o.default);
  function W(p, x) {
    return x === void 0 && (x = S.Legacy), R(p, x);
  }
  r.decodeHTML = W;
  function H(p) {
    return R(p, S.Attribute);
  }
  r.decodeHTMLAttribute = H;
  function F(p) {
    return R(p, S.Strict);
  }
  r.decodeHTMLStrict = F;
  function V(p) {
    return $(p, S.Strict);
  }
  r.decodeXML = V;
})(Pe);
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.QuoteType = void 0;
  var e = Pe, t;
  (function(s) {
    s[s.Tab = 9] = "Tab", s[s.NewLine = 10] = "NewLine", s[s.FormFeed = 12] = "FormFeed", s[s.CarriageReturn = 13] = "CarriageReturn", s[s.Space = 32] = "Space", s[s.ExclamationMark = 33] = "ExclamationMark", s[s.Number = 35] = "Number", s[s.Amp = 38] = "Amp", s[s.SingleQuote = 39] = "SingleQuote", s[s.DoubleQuote = 34] = "DoubleQuote", s[s.Dash = 45] = "Dash", s[s.Slash = 47] = "Slash", s[s.Zero = 48] = "Zero", s[s.Nine = 57] = "Nine", s[s.Semi = 59] = "Semi", s[s.Lt = 60] = "Lt", s[s.Eq = 61] = "Eq", s[s.Gt = 62] = "Gt", s[s.Questionmark = 63] = "Questionmark", s[s.UpperA = 65] = "UpperA", s[s.LowerA = 97] = "LowerA", s[s.UpperF = 70] = "UpperF", s[s.LowerF = 102] = "LowerF", s[s.UpperZ = 90] = "UpperZ", s[s.LowerZ = 122] = "LowerZ", s[s.LowerX = 120] = "LowerX", s[s.OpeningSquareBracket = 91] = "OpeningSquareBracket";
  })(t || (t = {}));
  var u;
  (function(s) {
    s[s.Text = 1] = "Text", s[s.BeforeTagName = 2] = "BeforeTagName", s[s.InTagName = 3] = "InTagName", s[s.InSelfClosingTag = 4] = "InSelfClosingTag", s[s.BeforeClosingTagName = 5] = "BeforeClosingTagName", s[s.InClosingTagName = 6] = "InClosingTagName", s[s.AfterClosingTagName = 7] = "AfterClosingTagName", s[s.BeforeAttributeName = 8] = "BeforeAttributeName", s[s.InAttributeName = 9] = "InAttributeName", s[s.AfterAttributeName = 10] = "AfterAttributeName", s[s.BeforeAttributeValue = 11] = "BeforeAttributeValue", s[s.InAttributeValueDq = 12] = "InAttributeValueDq", s[s.InAttributeValueSq = 13] = "InAttributeValueSq", s[s.InAttributeValueNq = 14] = "InAttributeValueNq", s[s.BeforeDeclaration = 15] = "BeforeDeclaration", s[s.InDeclaration = 16] = "InDeclaration", s[s.InProcessingInstruction = 17] = "InProcessingInstruction", s[s.BeforeComment = 18] = "BeforeComment", s[s.CDATASequence = 19] = "CDATASequence", s[s.InSpecialComment = 20] = "InSpecialComment", s[s.InCommentLike = 21] = "InCommentLike", s[s.BeforeSpecialS = 22] = "BeforeSpecialS", s[s.SpecialStartSequence = 23] = "SpecialStartSequence", s[s.InSpecialTag = 24] = "InSpecialTag", s[s.BeforeEntity = 25] = "BeforeEntity", s[s.BeforeNumericEntity = 26] = "BeforeNumericEntity", s[s.InNamedEntity = 27] = "InNamedEntity", s[s.InNumericEntity = 28] = "InNumericEntity", s[s.InHexEntity = 29] = "InHexEntity";
  })(u || (u = {}));
  function i(s) {
    return s === t.Space || s === t.NewLine || s === t.Tab || s === t.FormFeed || s === t.CarriageReturn;
  }
  function n(s) {
    return s === t.Slash || s === t.Gt || i(s);
  }
  function o(s) {
    return s >= t.Zero && s <= t.Nine;
  }
  function l(s) {
    return s >= t.LowerA && s <= t.LowerZ || s >= t.UpperA && s <= t.UpperZ;
  }
  function a(s) {
    return s >= t.UpperA && s <= t.UpperF || s >= t.LowerA && s <= t.LowerF;
  }
  var f;
  (function(s) {
    s[s.NoValue = 0] = "NoValue", s[s.Unquoted = 1] = "Unquoted", s[s.Single = 2] = "Single", s[s.Double = 3] = "Double";
  })(f = r.QuoteType || (r.QuoteType = {}));
  var d = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    CdataEnd: new Uint8Array([93, 93, 62]),
    CommentEnd: new Uint8Array([45, 45, 62]),
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
    // `</title`
  }, y = (
    /** @class */
    function() {
      function s(c, w) {
        var E = c.xmlMode, b = E === void 0 ? !1 : E, S = c.decodeEntities, N = S === void 0 ? !0 : S;
        this.cbs = w, this.state = u.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = u.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = b, this.decodeEntities = N, this.entityTrie = b ? e.xmlDecodeTree : e.htmlDecodeTree;
      }
      return s.prototype.reset = function() {
        this.state = u.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = u.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
      }, s.prototype.write = function(c) {
        this.offset += this.buffer.length, this.buffer = c, this.parse();
      }, s.prototype.end = function() {
        this.running && this.finish();
      }, s.prototype.pause = function() {
        this.running = !1;
      }, s.prototype.resume = function() {
        this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
      }, s.prototype.getIndex = function() {
        return this.index;
      }, s.prototype.getSectionStart = function() {
        return this.sectionStart;
      }, s.prototype.stateText = function(c) {
        c === t.Lt || !this.decodeEntities && this.fastForwardTo(t.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = u.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && c === t.Amp && (this.state = u.BeforeEntity);
      }, s.prototype.stateSpecialStartSequence = function(c) {
        var w = this.sequenceIndex === this.currentSequence.length, E = w ? (
          // If we are at the end of the sequence, make sure the tag name has ended
          n(c)
        ) : (
          // Otherwise, do a case-insensitive comparison
          (c | 32) === this.currentSequence[this.sequenceIndex]
        );
        if (!E)
          this.isSpecial = !1;
        else if (!w) {
          this.sequenceIndex++;
          return;
        }
        this.sequenceIndex = 0, this.state = u.InTagName, this.stateInTagName(c);
      }, s.prototype.stateInSpecialTag = function(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
          if (c === t.Gt || i(c)) {
            var w = this.index - this.currentSequence.length;
            if (this.sectionStart < w) {
              var E = this.index;
              this.index = w, this.cbs.ontext(this.sectionStart, w), this.index = E;
            }
            this.isSpecial = !1, this.sectionStart = w + 2, this.stateInClosingTagName(c);
            return;
          }
          this.sequenceIndex = 0;
        }
        (c | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === d.TitleEnd ? this.decodeEntities && c === t.Amp && (this.state = u.BeforeEntity) : this.fastForwardTo(t.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(c === t.Lt);
      }, s.prototype.stateCDATASequence = function(c) {
        c === d.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === d.Cdata.length && (this.state = u.InCommentLike, this.currentSequence = d.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = u.InDeclaration, this.stateInDeclaration(c));
      }, s.prototype.fastForwardTo = function(c) {
        for (; ++this.index < this.buffer.length + this.offset; )
          if (this.buffer.charCodeAt(this.index - this.offset) === c)
            return !0;
        return this.index = this.buffer.length + this.offset - 1, !1;
      }, s.prototype.stateInCommentLike = function(c) {
        c === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === d.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = u.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : c !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
      }, s.prototype.isTagStartChar = function(c) {
        return this.xmlMode ? !n(c) : l(c);
      }, s.prototype.startSpecial = function(c, w) {
        this.isSpecial = !0, this.currentSequence = c, this.sequenceIndex = w, this.state = u.SpecialStartSequence;
      }, s.prototype.stateBeforeTagName = function(c) {
        if (c === t.ExclamationMark)
          this.state = u.BeforeDeclaration, this.sectionStart = this.index + 1;
        else if (c === t.Questionmark)
          this.state = u.InProcessingInstruction, this.sectionStart = this.index + 1;
        else if (this.isTagStartChar(c)) {
          var w = c | 32;
          this.sectionStart = this.index, !this.xmlMode && w === d.TitleEnd[2] ? this.startSpecial(d.TitleEnd, 3) : this.state = !this.xmlMode && w === d.ScriptEnd[2] ? u.BeforeSpecialS : u.InTagName;
        } else c === t.Slash ? this.state = u.BeforeClosingTagName : (this.state = u.Text, this.stateText(c));
      }, s.prototype.stateInTagName = function(c) {
        n(c) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(c));
      }, s.prototype.stateBeforeClosingTagName = function(c) {
        i(c) || (c === t.Gt ? this.state = u.Text : (this.state = this.isTagStartChar(c) ? u.InClosingTagName : u.InSpecialComment, this.sectionStart = this.index));
      }, s.prototype.stateInClosingTagName = function(c) {
        (c === t.Gt || i(c)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.AfterClosingTagName, this.stateAfterClosingTagName(c));
      }, s.prototype.stateAfterClosingTagName = function(c) {
        (c === t.Gt || this.fastForwardTo(t.Gt)) && (this.state = u.Text, this.baseState = u.Text, this.sectionStart = this.index + 1);
      }, s.prototype.stateBeforeAttributeName = function(c) {
        c === t.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = u.InSpecialTag, this.sequenceIndex = 0) : this.state = u.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : c === t.Slash ? this.state = u.InSelfClosingTag : i(c) || (this.state = u.InAttributeName, this.sectionStart = this.index);
      }, s.prototype.stateInSelfClosingTag = function(c) {
        c === t.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = u.Text, this.baseState = u.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : i(c) || (this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(c));
      }, s.prototype.stateInAttributeName = function(c) {
        (c === t.Eq || n(c)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.AfterAttributeName, this.stateAfterAttributeName(c));
      }, s.prototype.stateAfterAttributeName = function(c) {
        c === t.Eq ? this.state = u.BeforeAttributeValue : c === t.Slash || c === t.Gt ? (this.cbs.onattribend(f.NoValue, this.index), this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(c)) : i(c) || (this.cbs.onattribend(f.NoValue, this.index), this.state = u.InAttributeName, this.sectionStart = this.index);
      }, s.prototype.stateBeforeAttributeValue = function(c) {
        c === t.DoubleQuote ? (this.state = u.InAttributeValueDq, this.sectionStart = this.index + 1) : c === t.SingleQuote ? (this.state = u.InAttributeValueSq, this.sectionStart = this.index + 1) : i(c) || (this.sectionStart = this.index, this.state = u.InAttributeValueNq, this.stateInAttributeValueNoQuotes(c));
      }, s.prototype.handleInAttributeValue = function(c, w) {
        c === w || !this.decodeEntities && this.fastForwardTo(w) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(w === t.DoubleQuote ? f.Double : f.Single, this.index), this.state = u.BeforeAttributeName) : this.decodeEntities && c === t.Amp && (this.baseState = this.state, this.state = u.BeforeEntity);
      }, s.prototype.stateInAttributeValueDoubleQuotes = function(c) {
        this.handleInAttributeValue(c, t.DoubleQuote);
      }, s.prototype.stateInAttributeValueSingleQuotes = function(c) {
        this.handleInAttributeValue(c, t.SingleQuote);
      }, s.prototype.stateInAttributeValueNoQuotes = function(c) {
        i(c) || c === t.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(f.Unquoted, this.index), this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(c)) : this.decodeEntities && c === t.Amp && (this.baseState = this.state, this.state = u.BeforeEntity);
      }, s.prototype.stateBeforeDeclaration = function(c) {
        c === t.OpeningSquareBracket ? (this.state = u.CDATASequence, this.sequenceIndex = 0) : this.state = c === t.Dash ? u.BeforeComment : u.InDeclaration;
      }, s.prototype.stateInDeclaration = function(c) {
        (c === t.Gt || this.fastForwardTo(t.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = u.Text, this.sectionStart = this.index + 1);
      }, s.prototype.stateInProcessingInstruction = function(c) {
        (c === t.Gt || this.fastForwardTo(t.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = u.Text, this.sectionStart = this.index + 1);
      }, s.prototype.stateBeforeComment = function(c) {
        c === t.Dash ? (this.state = u.InCommentLike, this.currentSequence = d.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = u.InDeclaration;
      }, s.prototype.stateInSpecialComment = function(c) {
        (c === t.Gt || this.fastForwardTo(t.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = u.Text, this.sectionStart = this.index + 1);
      }, s.prototype.stateBeforeSpecialS = function(c) {
        var w = c | 32;
        w === d.ScriptEnd[3] ? this.startSpecial(d.ScriptEnd, 4) : w === d.StyleEnd[3] ? this.startSpecial(d.StyleEnd, 4) : (this.state = u.InTagName, this.stateInTagName(c));
      }, s.prototype.stateBeforeEntity = function(c) {
        this.entityExcess = 1, this.entityResult = 0, c === t.Number ? this.state = u.BeforeNumericEntity : c === t.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = u.InNamedEntity, this.stateInNamedEntity(c));
      }, s.prototype.stateInNamedEntity = function(c) {
        if (this.entityExcess += 1, this.trieIndex = (0, e.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c), this.trieIndex < 0) {
          this.emitNamedEntity(), this.index--;
          return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var w = this.trieCurrent & e.BinTrieFlags.VALUE_LENGTH;
        if (w) {
          var E = (w >> 14) - 1;
          if (!this.allowLegacyEntity() && c !== t.Semi)
            this.trieIndex += E;
          else {
            var b = this.index - this.entityExcess + 1;
            b > this.sectionStart && this.emitPartial(this.sectionStart, b), this.entityResult = this.trieIndex, this.trieIndex += E, this.entityExcess = 0, this.sectionStart = this.index + 1, E === 0 && this.emitNamedEntity();
          }
        }
      }, s.prototype.emitNamedEntity = function() {
        if (this.state = this.baseState, this.entityResult !== 0) {
          var c = (this.entityTrie[this.entityResult] & e.BinTrieFlags.VALUE_LENGTH) >> 14;
          switch (c) {
            case 1: {
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~e.BinTrieFlags.VALUE_LENGTH);
              break;
            }
            case 2: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            }
            case 3:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        }
      }, s.prototype.stateBeforeNumericEntity = function(c) {
        (c | 32) === t.LowerX ? (this.entityExcess++, this.state = u.InHexEntity) : (this.state = u.InNumericEntity, this.stateInNumericEntity(c));
      }, s.prototype.emitNumericEntity = function(c) {
        var w = this.index - this.entityExcess - 1, E = w + 2 + +(this.state === u.InHexEntity);
        E !== this.index && (w > this.sectionStart && this.emitPartial(this.sectionStart, w), this.sectionStart = this.index + Number(c), this.emitCodePoint((0, e.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
      }, s.prototype.stateInNumericEntity = function(c) {
        c === t.Semi ? this.emitNumericEntity(!0) : o(c) ? (this.entityResult = this.entityResult * 10 + (c - t.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, s.prototype.stateInHexEntity = function(c) {
        c === t.Semi ? this.emitNumericEntity(!0) : o(c) ? (this.entityResult = this.entityResult * 16 + (c - t.Zero), this.entityExcess++) : a(c) ? (this.entityResult = this.entityResult * 16 + ((c | 32) - t.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, s.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === u.Text || this.baseState === u.InSpecialTag);
      }, s.prototype.cleanup = function() {
        this.running && this.sectionStart !== this.index && (this.state === u.Text || this.state === u.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === u.InAttributeValueDq || this.state === u.InAttributeValueSq || this.state === u.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
      }, s.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
      }, s.prototype.parse = function() {
        for (; this.shouldContinue(); ) {
          var c = this.buffer.charCodeAt(this.index - this.offset);
          switch (this.state) {
            case u.Text: {
              this.stateText(c);
              break;
            }
            case u.SpecialStartSequence: {
              this.stateSpecialStartSequence(c);
              break;
            }
            case u.InSpecialTag: {
              this.stateInSpecialTag(c);
              break;
            }
            case u.CDATASequence: {
              this.stateCDATASequence(c);
              break;
            }
            case u.InAttributeValueDq: {
              this.stateInAttributeValueDoubleQuotes(c);
              break;
            }
            case u.InAttributeName: {
              this.stateInAttributeName(c);
              break;
            }
            case u.InCommentLike: {
              this.stateInCommentLike(c);
              break;
            }
            case u.InSpecialComment: {
              this.stateInSpecialComment(c);
              break;
            }
            case u.BeforeAttributeName: {
              this.stateBeforeAttributeName(c);
              break;
            }
            case u.InTagName: {
              this.stateInTagName(c);
              break;
            }
            case u.InClosingTagName: {
              this.stateInClosingTagName(c);
              break;
            }
            case u.BeforeTagName: {
              this.stateBeforeTagName(c);
              break;
            }
            case u.AfterAttributeName: {
              this.stateAfterAttributeName(c);
              break;
            }
            case u.InAttributeValueSq: {
              this.stateInAttributeValueSingleQuotes(c);
              break;
            }
            case u.BeforeAttributeValue: {
              this.stateBeforeAttributeValue(c);
              break;
            }
            case u.BeforeClosingTagName: {
              this.stateBeforeClosingTagName(c);
              break;
            }
            case u.AfterClosingTagName: {
              this.stateAfterClosingTagName(c);
              break;
            }
            case u.BeforeSpecialS: {
              this.stateBeforeSpecialS(c);
              break;
            }
            case u.InAttributeValueNq: {
              this.stateInAttributeValueNoQuotes(c);
              break;
            }
            case u.InSelfClosingTag: {
              this.stateInSelfClosingTag(c);
              break;
            }
            case u.InDeclaration: {
              this.stateInDeclaration(c);
              break;
            }
            case u.BeforeDeclaration: {
              this.stateBeforeDeclaration(c);
              break;
            }
            case u.BeforeComment: {
              this.stateBeforeComment(c);
              break;
            }
            case u.InProcessingInstruction: {
              this.stateInProcessingInstruction(c);
              break;
            }
            case u.InNamedEntity: {
              this.stateInNamedEntity(c);
              break;
            }
            case u.BeforeEntity: {
              this.stateBeforeEntity(c);
              break;
            }
            case u.InHexEntity: {
              this.stateInHexEntity(c);
              break;
            }
            case u.InNumericEntity: {
              this.stateInNumericEntity(c);
              break;
            }
            default:
              this.stateBeforeNumericEntity(c);
          }
          this.index++;
        }
        this.cleanup();
      }, s.prototype.finish = function() {
        this.state === u.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
      }, s.prototype.handleTrailingData = function() {
        var c = this.buffer.length + this.offset;
        this.state === u.InCommentLike ? this.currentSequence === d.CdataEnd ? this.cbs.oncdata(this.sectionStart, c, 0) : this.cbs.oncomment(this.sectionStart, c, 0) : this.state === u.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === u.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === u.InTagName || this.state === u.BeforeAttributeName || this.state === u.BeforeAttributeValue || this.state === u.AfterAttributeName || this.state === u.InAttributeName || this.state === u.InAttributeValueSq || this.state === u.InAttributeValueDq || this.state === u.InAttributeValueNq || this.state === u.InClosingTagName || this.cbs.ontext(this.sectionStart, c);
      }, s.prototype.emitPartial = function(c, w) {
        this.baseState !== u.Text && this.baseState !== u.InSpecialTag ? this.cbs.onattribdata(c, w) : this.cbs.ontext(c, w);
      }, s.prototype.emitCodePoint = function(c) {
        this.baseState !== u.Text && this.baseState !== u.InSpecialTag ? this.cbs.onattribentity(c) : this.cbs.ontextentity(c);
      }, s;
    }()
  );
  r.default = y;
})(zt);
var oi = O && O.__createBinding || (Object.create ? function(r, e, t, u) {
  u === void 0 && (u = t);
  var i = Object.getOwnPropertyDescriptor(e, t);
  (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return e[t];
  } }), Object.defineProperty(r, u, i);
} : function(r, e, t, u) {
  u === void 0 && (u = t), r[u] = e[t];
}), ci = O && O.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), li = O && O.__importStar || function(r) {
  if (r && r.__esModule) return r;
  var e = {};
  if (r != null) for (var t in r) t !== "default" && Object.prototype.hasOwnProperty.call(r, t) && oi(e, r, t);
  return ci(e, r), e;
};
Object.defineProperty(De, "__esModule", { value: !0 });
De.Parser = void 0;
var ze = li(zt), du = Pe, ge = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), B = /* @__PURE__ */ new Set(["p"]), hu = /* @__PURE__ */ new Set(["thead", "tbody"]), pu = /* @__PURE__ */ new Set(["dd", "dt"]), bu = /* @__PURE__ */ new Set(["rt", "rp"]), fi = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", B],
  ["h1", B],
  ["h2", B],
  ["h3", B],
  ["h4", B],
  ["h5", B],
  ["h6", B],
  ["select", ge],
  ["input", ge],
  ["output", ge],
  ["button", ge],
  ["datalist", ge],
  ["textarea", ge],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", pu],
  ["dt", pu],
  ["address", B],
  ["article", B],
  ["aside", B],
  ["blockquote", B],
  ["details", B],
  ["div", B],
  ["dl", B],
  ["fieldset", B],
  ["figcaption", B],
  ["figure", B],
  ["footer", B],
  ["form", B],
  ["header", B],
  ["hr", B],
  ["main", B],
  ["nav", B],
  ["ol", B],
  ["pre", B],
  ["section", B],
  ["table", B],
  ["ul", B],
  ["rt", bu],
  ["rp", bu],
  ["tbody", hu],
  ["tfoot", hu]
]), di = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), mu = /* @__PURE__ */ new Set(["math", "svg"]), gu = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), hi = /\s|\//, pi = (
  /** @class */
  function() {
    function r(e, t) {
      t === void 0 && (t = {});
      var u, i, n, o, l;
      this.options = t, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = e ?? {}, this.lowerCaseTagNames = (u = t.lowerCaseTags) !== null && u !== void 0 ? u : !t.xmlMode, this.lowerCaseAttributeNames = (i = t.lowerCaseAttributeNames) !== null && i !== void 0 ? i : !t.xmlMode, this.tokenizer = new ((n = t.Tokenizer) !== null && n !== void 0 ? n : ze.default)(this.options, this), (l = (o = this.cbs).onparserinit) === null || l === void 0 || l.call(o, this);
    }
    return r.prototype.ontext = function(e, t) {
      var u, i, n = this.getSlice(e, t);
      this.endIndex = t - 1, (i = (u = this.cbs).ontext) === null || i === void 0 || i.call(u, n), this.startIndex = t;
    }, r.prototype.ontextentity = function(e) {
      var t, u, i = this.tokenizer.getSectionStart();
      this.endIndex = i - 1, (u = (t = this.cbs).ontext) === null || u === void 0 || u.call(t, (0, du.fromCodePoint)(e)), this.startIndex = i;
    }, r.prototype.isVoidElement = function(e) {
      return !this.options.xmlMode && di.has(e);
    }, r.prototype.onopentagname = function(e, t) {
      this.endIndex = t;
      var u = this.getSlice(e, t);
      this.lowerCaseTagNames && (u = u.toLowerCase()), this.emitOpenTag(u);
    }, r.prototype.emitOpenTag = function(e) {
      var t, u, i, n;
      this.openTagStart = this.startIndex, this.tagname = e;
      var o = !this.options.xmlMode && fi.get(e);
      if (o)
        for (; this.stack.length > 0 && o.has(this.stack[this.stack.length - 1]); ) {
          var l = this.stack.pop();
          (u = (t = this.cbs).onclosetag) === null || u === void 0 || u.call(t, l, !0);
        }
      this.isVoidElement(e) || (this.stack.push(e), mu.has(e) ? this.foreignContext.push(!0) : gu.has(e) && this.foreignContext.push(!1)), (n = (i = this.cbs).onopentagname) === null || n === void 0 || n.call(i, e), this.cbs.onopentag && (this.attribs = {});
    }, r.prototype.endOpenTag = function(e) {
      var t, u;
      this.startIndex = this.openTagStart, this.attribs && ((u = (t = this.cbs).onopentag) === null || u === void 0 || u.call(t, this.tagname, this.attribs, e), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
    }, r.prototype.onopentagend = function(e) {
      this.endIndex = e, this.endOpenTag(!1), this.startIndex = e + 1;
    }, r.prototype.onclosetag = function(e, t) {
      var u, i, n, o, l, a;
      this.endIndex = t;
      var f = this.getSlice(e, t);
      if (this.lowerCaseTagNames && (f = f.toLowerCase()), (mu.has(f) || gu.has(f)) && this.foreignContext.pop(), this.isVoidElement(f))
        !this.options.xmlMode && f === "br" && ((i = (u = this.cbs).onopentagname) === null || i === void 0 || i.call(u, "br"), (o = (n = this.cbs).onopentag) === null || o === void 0 || o.call(n, "br", {}, !0), (a = (l = this.cbs).onclosetag) === null || a === void 0 || a.call(l, "br", !1));
      else {
        var d = this.stack.lastIndexOf(f);
        if (d !== -1)
          if (this.cbs.onclosetag)
            for (var y = this.stack.length - d; y--; )
              this.cbs.onclosetag(this.stack.pop(), y !== 0);
          else
            this.stack.length = d;
        else !this.options.xmlMode && f === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
      }
      this.startIndex = t + 1;
    }, r.prototype.onselfclosingtag = function(e) {
      this.endIndex = e, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = e + 1) : this.onopentagend(e);
    }, r.prototype.closeCurrentTag = function(e) {
      var t, u, i = this.tagname;
      this.endOpenTag(e), this.stack[this.stack.length - 1] === i && ((u = (t = this.cbs).onclosetag) === null || u === void 0 || u.call(t, i, !e), this.stack.pop());
    }, r.prototype.onattribname = function(e, t) {
      this.startIndex = e;
      var u = this.getSlice(e, t);
      this.attribname = this.lowerCaseAttributeNames ? u.toLowerCase() : u;
    }, r.prototype.onattribdata = function(e, t) {
      this.attribvalue += this.getSlice(e, t);
    }, r.prototype.onattribentity = function(e) {
      this.attribvalue += (0, du.fromCodePoint)(e);
    }, r.prototype.onattribend = function(e, t) {
      var u, i;
      this.endIndex = t, (i = (u = this.cbs).onattribute) === null || i === void 0 || i.call(u, this.attribname, this.attribvalue, e === ze.QuoteType.Double ? '"' : e === ze.QuoteType.Single ? "'" : e === ze.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
    }, r.prototype.getInstructionName = function(e) {
      var t = e.search(hi), u = t < 0 ? e : e.substr(0, t);
      return this.lowerCaseTagNames && (u = u.toLowerCase()), u;
    }, r.prototype.ondeclaration = function(e, t) {
      this.endIndex = t;
      var u = this.getSlice(e, t);
      if (this.cbs.onprocessinginstruction) {
        var i = this.getInstructionName(u);
        this.cbs.onprocessinginstruction("!".concat(i), "!".concat(u));
      }
      this.startIndex = t + 1;
    }, r.prototype.onprocessinginstruction = function(e, t) {
      this.endIndex = t;
      var u = this.getSlice(e, t);
      if (this.cbs.onprocessinginstruction) {
        var i = this.getInstructionName(u);
        this.cbs.onprocessinginstruction("?".concat(i), "?".concat(u));
      }
      this.startIndex = t + 1;
    }, r.prototype.oncomment = function(e, t, u) {
      var i, n, o, l;
      this.endIndex = t, (n = (i = this.cbs).oncomment) === null || n === void 0 || n.call(i, this.getSlice(e, t - u)), (l = (o = this.cbs).oncommentend) === null || l === void 0 || l.call(o), this.startIndex = t + 1;
    }, r.prototype.oncdata = function(e, t, u) {
      var i, n, o, l, a, f, d, y, s, c;
      this.endIndex = t;
      var w = this.getSlice(e, t - u);
      this.options.xmlMode || this.options.recognizeCDATA ? ((n = (i = this.cbs).oncdatastart) === null || n === void 0 || n.call(i), (l = (o = this.cbs).ontext) === null || l === void 0 || l.call(o, w), (f = (a = this.cbs).oncdataend) === null || f === void 0 || f.call(a)) : ((y = (d = this.cbs).oncomment) === null || y === void 0 || y.call(d, "[CDATA[".concat(w, "]]")), (c = (s = this.cbs).oncommentend) === null || c === void 0 || c.call(s)), this.startIndex = t + 1;
    }, r.prototype.onend = function() {
      var e, t;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var u = this.stack.length; u > 0; this.cbs.onclosetag(this.stack[--u], !0))
          ;
      }
      (t = (e = this.cbs).onend) === null || t === void 0 || t.call(e);
    }, r.prototype.reset = function() {
      var e, t, u, i;
      (t = (e = this.cbs).onreset) === null || t === void 0 || t.call(e), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (i = (u = this.cbs).onparserinit) === null || i === void 0 || i.call(u, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
    }, r.prototype.parseComplete = function(e) {
      this.reset(), this.end(e);
    }, r.prototype.getSlice = function(e, t) {
      for (; e - this.bufferOffset >= this.buffers[0].length; )
        this.shiftBuffer();
      for (var u = this.buffers[0].slice(e - this.bufferOffset, t - this.bufferOffset); t - this.bufferOffset > this.buffers[0].length; )
        this.shiftBuffer(), u += this.buffers[0].slice(0, t - this.bufferOffset);
      return u;
    }, r.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
    }, r.prototype.write = function(e) {
      var t, u;
      if (this.ended) {
        (u = (t = this.cbs).onerror) === null || u === void 0 || u.call(t, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(e), this.tokenizer.running && (this.tokenizer.write(e), this.writeIndex++);
    }, r.prototype.end = function(e) {
      var t, u;
      if (this.ended) {
        (u = (t = this.cbs).onerror) === null || u === void 0 || u.call(t, new Error(".end() after done!"));
        return;
      }
      e && this.write(e), this.ended = !0, this.tokenizer.end();
    }, r.prototype.pause = function() {
      this.tokenizer.pause();
    }, r.prototype.resume = function() {
      for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      this.ended && this.tokenizer.end();
    }, r.prototype.parseChunk = function(e) {
      this.write(e);
    }, r.prototype.done = function(e) {
      this.end(e);
    }, r;
  }()
);
De.Parser = pi;
var re = {}, Te = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.Doctype = r.CDATA = r.Tag = r.Style = r.Script = r.Comment = r.Directive = r.Text = r.Root = r.isTag = r.ElementType = void 0;
  var e;
  (function(u) {
    u.Root = "root", u.Text = "text", u.Directive = "directive", u.Comment = "comment", u.Script = "script", u.Style = "style", u.Tag = "tag", u.CDATA = "cdata", u.Doctype = "doctype";
  })(e = r.ElementType || (r.ElementType = {}));
  function t(u) {
    return u.type === e.Tag || u.type === e.Script || u.type === e.Style;
  }
  r.isTag = t, r.Root = e.Root, r.Text = e.Text, r.Directive = e.Directive, r.Comment = e.Comment, r.Script = e.Script, r.Style = e.Style, r.Tag = e.Tag, r.CDATA = e.CDATA, r.Doctype = e.Doctype;
})(Te);
var C = {}, oe = O && O.__extends || /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, i) {
      u.__proto__ = i;
    } || function(u, i) {
      for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (u[n] = i[n]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function u() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (u.prototype = t.prototype, new u());
  };
}(), Ce = O && O.__assign || function() {
  return Ce = Object.assign || function(r) {
    for (var e, t = 1, u = arguments.length; t < u; t++) {
      e = arguments[t];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Ce.apply(this, arguments);
};
Object.defineProperty(C, "__esModule", { value: !0 });
C.cloneNode = C.hasChildren = C.isDocument = C.isDirective = C.isComment = C.isText = C.isCDATA = C.isTag = C.Element = C.Document = C.CDATA = C.NodeWithChildren = C.ProcessingInstruction = C.Comment = C.Text = C.DataNode = C.Node = void 0;
var G = Te, Xt = (
  /** @class */
  function() {
    function r() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(r.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(e) {
        this.parent = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(e) {
        this.prev = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(e) {
        this.next = e;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.cloneNode = function(e) {
      return e === void 0 && (e = !1), Qt(this, e);
    }, r;
  }()
);
C.Node = Xt;
var ht = (
  /** @class */
  function(r) {
    oe(e, r);
    function e(t) {
      var u = r.call(this) || this;
      return u.data = t, u;
    }
    return Object.defineProperty(e.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(t) {
        this.data = t;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(Xt)
);
C.DataNode = ht;
var Fu = (
  /** @class */
  function(r) {
    oe(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.type = G.ElementType.Text, t;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(ht)
);
C.Text = Fu;
var Vu = (
  /** @class */
  function(r) {
    oe(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.type = G.ElementType.Comment, t;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(ht)
);
C.Comment = Vu;
var zu = (
  /** @class */
  function(r) {
    oe(e, r);
    function e(t, u) {
      var i = r.call(this, u) || this;
      return i.name = t, i.type = G.ElementType.Directive, i;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(ht)
);
C.ProcessingInstruction = zu;
var pt = (
  /** @class */
  function(r) {
    oe(e, r);
    function e(t) {
      var u = r.call(this) || this;
      return u.children = t, u;
    }
    return Object.defineProperty(e.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var t;
        return (t = this.children[0]) !== null && t !== void 0 ? t : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(t) {
        this.children = t;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(Xt)
);
C.NodeWithChildren = pt;
var Gu = (
  /** @class */
  function(r) {
    oe(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.type = G.ElementType.CDATA, t;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(pt)
);
C.CDATA = Gu;
var Wu = (
  /** @class */
  function(r) {
    oe(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.type = G.ElementType.Root, t;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(pt)
);
C.Document = Wu;
var Xu = (
  /** @class */
  function(r) {
    oe(e, r);
    function e(t, u, i, n) {
      i === void 0 && (i = []), n === void 0 && (n = t === "script" ? G.ElementType.Script : t === "style" ? G.ElementType.Style : G.ElementType.Tag);
      var o = r.call(this, i) || this;
      return o.name = t, o.attribs = u, o.type = n, o;
    }
    return Object.defineProperty(e.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(t) {
        this.name = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t = this;
        return Object.keys(this.attribs).map(function(u) {
          var i, n;
          return {
            name: u,
            value: t.attribs[u],
            namespace: (i = t["x-attribsNamespace"]) === null || i === void 0 ? void 0 : i[u],
            prefix: (n = t["x-attribsPrefix"]) === null || n === void 0 ? void 0 : n[u]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(pt)
);
C.Element = Xu;
function Qu(r) {
  return (0, G.isTag)(r);
}
C.isTag = Qu;
function Ju(r) {
  return r.type === G.ElementType.CDATA;
}
C.isCDATA = Ju;
function Zu(r) {
  return r.type === G.ElementType.Text;
}
C.isText = Zu;
function Yu(r) {
  return r.type === G.ElementType.Comment;
}
C.isComment = Yu;
function Ku(r) {
  return r.type === G.ElementType.Directive;
}
C.isDirective = Ku;
function er(r) {
  return r.type === G.ElementType.Root;
}
C.isDocument = er;
function bi(r) {
  return Object.prototype.hasOwnProperty.call(r, "children");
}
C.hasChildren = bi;
function Qt(r, e) {
  e === void 0 && (e = !1);
  var t;
  if (Zu(r))
    t = new Fu(r.data);
  else if (Yu(r))
    t = new Vu(r.data);
  else if (Qu(r)) {
    var u = e ? St(r.children) : [], i = new Xu(r.name, Ce({}, r.attribs), u);
    u.forEach(function(a) {
      return a.parent = i;
    }), r.namespace != null && (i.namespace = r.namespace), r["x-attribsNamespace"] && (i["x-attribsNamespace"] = Ce({}, r["x-attribsNamespace"])), r["x-attribsPrefix"] && (i["x-attribsPrefix"] = Ce({}, r["x-attribsPrefix"])), t = i;
  } else if (Ju(r)) {
    var u = e ? St(r.children) : [], n = new Gu(u);
    u.forEach(function(f) {
      return f.parent = n;
    }), t = n;
  } else if (er(r)) {
    var u = e ? St(r.children) : [], o = new Wu(u);
    u.forEach(function(f) {
      return f.parent = o;
    }), r["x-mode"] && (o["x-mode"] = r["x-mode"]), t = o;
  } else if (Ku(r)) {
    var l = new zu(r.name, r.data);
    r["x-name"] != null && (l["x-name"] = r["x-name"], l["x-publicId"] = r["x-publicId"], l["x-systemId"] = r["x-systemId"]), t = l;
  } else
    throw new Error("Not implemented yet: ".concat(r.type));
  return t.startIndex = r.startIndex, t.endIndex = r.endIndex, r.sourceCodeLocation != null && (t.sourceCodeLocation = r.sourceCodeLocation), t;
}
C.cloneNode = Qt;
function St(r) {
  for (var e = r.map(function(u) {
    return Qt(u, !0);
  }), t = 1; t < e.length; t++)
    e[t].prev = e[t - 1], e[t - 1].next = e[t];
  return e;
}
(function(r) {
  var e = O && O.__createBinding || (Object.create ? function(l, a, f, d) {
    d === void 0 && (d = f);
    var y = Object.getOwnPropertyDescriptor(a, f);
    (!y || ("get" in y ? !a.__esModule : y.writable || y.configurable)) && (y = { enumerable: !0, get: function() {
      return a[f];
    } }), Object.defineProperty(l, d, y);
  } : function(l, a, f, d) {
    d === void 0 && (d = f), l[d] = a[f];
  }), t = O && O.__exportStar || function(l, a) {
    for (var f in l) f !== "default" && !Object.prototype.hasOwnProperty.call(a, f) && e(a, l, f);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.DomHandler = void 0;
  var u = Te, i = C;
  t(C, r);
  var n = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, o = (
    /** @class */
    function() {
      function l(a, f, d) {
        this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof f == "function" && (d = f, f = n), typeof a == "object" && (f = a, a = void 0), this.callback = a ?? null, this.options = f ?? n, this.elementCB = d ?? null;
      }
      return l.prototype.onparserinit = function(a) {
        this.parser = a;
      }, l.prototype.onreset = function() {
        this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, l.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, l.prototype.onerror = function(a) {
        this.handleCallback(a);
      }, l.prototype.onclosetag = function() {
        this.lastNode = null;
        var a = this.tagStack.pop();
        this.options.withEndIndices && (a.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(a);
      }, l.prototype.onopentag = function(a, f) {
        var d = this.options.xmlMode ? u.ElementType.Tag : void 0, y = new i.Element(a, f, void 0, d);
        this.addNode(y), this.tagStack.push(y);
      }, l.prototype.ontext = function(a) {
        var f = this.lastNode;
        if (f && f.type === u.ElementType.Text)
          f.data += a, this.options.withEndIndices && (f.endIndex = this.parser.endIndex);
        else {
          var d = new i.Text(a);
          this.addNode(d), this.lastNode = d;
        }
      }, l.prototype.oncomment = function(a) {
        if (this.lastNode && this.lastNode.type === u.ElementType.Comment) {
          this.lastNode.data += a;
          return;
        }
        var f = new i.Comment(a);
        this.addNode(f), this.lastNode = f;
      }, l.prototype.oncommentend = function() {
        this.lastNode = null;
      }, l.prototype.oncdatastart = function() {
        var a = new i.Text(""), f = new i.CDATA([a]);
        this.addNode(f), a.parent = f, this.lastNode = a;
      }, l.prototype.oncdataend = function() {
        this.lastNode = null;
      }, l.prototype.onprocessinginstruction = function(a, f) {
        var d = new i.ProcessingInstruction(a, f);
        this.addNode(d);
      }, l.prototype.handleCallback = function(a) {
        if (typeof this.callback == "function")
          this.callback(a, this.dom);
        else if (a)
          throw a;
      }, l.prototype.addNode = function(a) {
        var f = this.tagStack[this.tagStack.length - 1], d = f.children[f.children.length - 1];
        this.options.withStartIndices && (a.startIndex = this.parser.startIndex), this.options.withEndIndices && (a.endIndex = this.parser.endIndex), f.children.push(a), d && (a.prev = d, d.next = a), a.parent = f, this.lastNode = null;
      }, l;
    }()
  );
  r.DomHandler = o, r.default = o;
})(re);
var tt = {}, ce = {}, je = {}, tr = {}, he = {}, Jt = {};
Object.defineProperty(Jt, "__esModule", { value: !0 });
function Ge(r) {
  for (var e = 1; e < r.length; e++)
    r[e][0] += r[e - 1][0] + 1;
  return r;
}
Jt.default = new Map(/* @__PURE__ */ Ge([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ Ge([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ Ge([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ Ge([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var nt = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.escapeText = r.escapeAttribute = r.escapeUTF8 = r.escape = r.encodeXML = r.getCodePoint = r.xmlReplacer = void 0, r.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var e = /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [39, "&apos;"],
    [60, "&lt;"],
    [62, "&gt;"]
  ]);
  r.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? function(i, n) {
    return i.codePointAt(n);
  } : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(i, n) {
      return (i.charCodeAt(n) & 64512) === 55296 ? (i.charCodeAt(n) - 55296) * 1024 + i.charCodeAt(n + 1) - 56320 + 65536 : i.charCodeAt(n);
    }
  );
  function t(i) {
    for (var n = "", o = 0, l; (l = r.xmlReplacer.exec(i)) !== null; ) {
      var a = l.index, f = i.charCodeAt(a), d = e.get(f);
      d !== void 0 ? (n += i.substring(o, a) + d, o = a + 1) : (n += "".concat(i.substring(o, a), "&#x").concat((0, r.getCodePoint)(i, a).toString(16), ";"), o = r.xmlReplacer.lastIndex += +((f & 64512) === 55296));
    }
    return n + i.substr(o);
  }
  r.encodeXML = t, r.escape = t;
  function u(i, n) {
    return function(l) {
      for (var a, f = 0, d = ""; a = i.exec(l); )
        f !== a.index && (d += l.substring(f, a.index)), d += n.get(a[0].charCodeAt(0)), f = a.index + 1;
      return d + l.substring(f);
    };
  }
  r.escapeUTF8 = u(/[&<>'"]/g, e), r.escapeAttribute = u(/["&\u00A0]/g, /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [160, "&nbsp;"]
  ])), r.escapeText = u(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
    [38, "&amp;"],
    [60, "&lt;"],
    [62, "&gt;"],
    [160, "&nbsp;"]
  ]));
})(nt);
var mi = O && O.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(he, "__esModule", { value: !0 });
he.encodeNonAsciiHTML = he.encodeHTML = void 0;
var gi = mi(Jt), ur = nt, yi = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function xi(r) {
  return rr(yi, r);
}
he.encodeHTML = xi;
function vi(r) {
  return rr(ur.xmlReplacer, r);
}
he.encodeNonAsciiHTML = vi;
function rr(r, e) {
  for (var t = "", u = 0, i; (i = r.exec(e)) !== null; ) {
    var n = i.index;
    t += e.substring(u, n);
    var o = e.charCodeAt(n), l = gi.default.get(o);
    if (typeof l == "object") {
      if (n + 1 < e.length) {
        var a = e.charCodeAt(n + 1), f = typeof l.n == "number" ? l.n === a ? l.o : void 0 : l.n.get(a);
        if (f !== void 0) {
          t += f, u = r.lastIndex += 1;
          continue;
        }
      }
      l = l.v;
    }
    if (l !== void 0)
      t += l, u = n + 1;
    else {
      var d = (0, ur.getCodePoint)(e, n);
      t += "&#x".concat(d.toString(16), ";"), u = r.lastIndex += +(d !== o);
    }
  }
  return t + e.substr(u);
}
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.decodeXMLStrict = r.decodeHTML5Strict = r.decodeHTML4Strict = r.decodeHTML5 = r.decodeHTML4 = r.decodeHTMLAttribute = r.decodeHTMLStrict = r.decodeHTML = r.decodeXML = r.DecodingMode = r.EntityDecoder = r.encodeHTML5 = r.encodeHTML4 = r.encodeNonAsciiHTML = r.encodeHTML = r.escapeText = r.escapeAttribute = r.escapeUTF8 = r.escape = r.encodeXML = r.encode = r.decodeStrict = r.decode = r.EncodingMode = r.EntityLevel = void 0;
  var e = Pe, t = he, u = nt, i;
  (function(s) {
    s[s.XML = 0] = "XML", s[s.HTML = 1] = "HTML";
  })(i = r.EntityLevel || (r.EntityLevel = {}));
  var n;
  (function(s) {
    s[s.UTF8 = 0] = "UTF8", s[s.ASCII = 1] = "ASCII", s[s.Extensive = 2] = "Extensive", s[s.Attribute = 3] = "Attribute", s[s.Text = 4] = "Text";
  })(n = r.EncodingMode || (r.EncodingMode = {}));
  function o(s, c) {
    c === void 0 && (c = i.XML);
    var w = typeof c == "number" ? c : c.level;
    if (w === i.HTML) {
      var E = typeof c == "object" ? c.mode : void 0;
      return (0, e.decodeHTML)(s, E);
    }
    return (0, e.decodeXML)(s);
  }
  r.decode = o;
  function l(s, c) {
    var w;
    c === void 0 && (c = i.XML);
    var E = typeof c == "number" ? { level: c } : c;
    return (w = E.mode) !== null && w !== void 0 || (E.mode = e.DecodingMode.Strict), o(s, E);
  }
  r.decodeStrict = l;
  function a(s, c) {
    c === void 0 && (c = i.XML);
    var w = typeof c == "number" ? { level: c } : c;
    return w.mode === n.UTF8 ? (0, u.escapeUTF8)(s) : w.mode === n.Attribute ? (0, u.escapeAttribute)(s) : w.mode === n.Text ? (0, u.escapeText)(s) : w.level === i.HTML ? w.mode === n.ASCII ? (0, t.encodeNonAsciiHTML)(s) : (0, t.encodeHTML)(s) : (0, u.encodeXML)(s);
  }
  r.encode = a;
  var f = nt;
  Object.defineProperty(r, "encodeXML", { enumerable: !0, get: function() {
    return f.encodeXML;
  } }), Object.defineProperty(r, "escape", { enumerable: !0, get: function() {
    return f.escape;
  } }), Object.defineProperty(r, "escapeUTF8", { enumerable: !0, get: function() {
    return f.escapeUTF8;
  } }), Object.defineProperty(r, "escapeAttribute", { enumerable: !0, get: function() {
    return f.escapeAttribute;
  } }), Object.defineProperty(r, "escapeText", { enumerable: !0, get: function() {
    return f.escapeText;
  } });
  var d = he;
  Object.defineProperty(r, "encodeHTML", { enumerable: !0, get: function() {
    return d.encodeHTML;
  } }), Object.defineProperty(r, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
    return d.encodeNonAsciiHTML;
  } }), Object.defineProperty(r, "encodeHTML4", { enumerable: !0, get: function() {
    return d.encodeHTML;
  } }), Object.defineProperty(r, "encodeHTML5", { enumerable: !0, get: function() {
    return d.encodeHTML;
  } });
  var y = Pe;
  Object.defineProperty(r, "EntityDecoder", { enumerable: !0, get: function() {
    return y.EntityDecoder;
  } }), Object.defineProperty(r, "DecodingMode", { enumerable: !0, get: function() {
    return y.DecodingMode;
  } }), Object.defineProperty(r, "decodeXML", { enumerable: !0, get: function() {
    return y.decodeXML;
  } }), Object.defineProperty(r, "decodeHTML", { enumerable: !0, get: function() {
    return y.decodeHTML;
  } }), Object.defineProperty(r, "decodeHTMLStrict", { enumerable: !0, get: function() {
    return y.decodeHTMLStrict;
  } }), Object.defineProperty(r, "decodeHTMLAttribute", { enumerable: !0, get: function() {
    return y.decodeHTMLAttribute;
  } }), Object.defineProperty(r, "decodeHTML4", { enumerable: !0, get: function() {
    return y.decodeHTML;
  } }), Object.defineProperty(r, "decodeHTML5", { enumerable: !0, get: function() {
    return y.decodeHTML;
  } }), Object.defineProperty(r, "decodeHTML4Strict", { enumerable: !0, get: function() {
    return y.decodeHTMLStrict;
  } }), Object.defineProperty(r, "decodeHTML5Strict", { enumerable: !0, get: function() {
    return y.decodeHTMLStrict;
  } }), Object.defineProperty(r, "decodeXMLStrict", { enumerable: !0, get: function() {
    return y.decodeXML;
  } });
})(tr);
var xe = {};
Object.defineProperty(xe, "__esModule", { value: !0 });
xe.attributeNames = xe.elementNames = void 0;
xe.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(r) {
  return [r.toLowerCase(), r];
}));
xe.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(r) {
  return [r.toLowerCase(), r];
}));
var ye = O && O.__assign || function() {
  return ye = Object.assign || function(r) {
    for (var e, t = 1, u = arguments.length; t < u; t++) {
      e = arguments[t];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, ye.apply(this, arguments);
}, wi = O && O.__createBinding || (Object.create ? function(r, e, t, u) {
  u === void 0 && (u = t);
  var i = Object.getOwnPropertyDescriptor(e, t);
  (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return e[t];
  } }), Object.defineProperty(r, u, i);
} : function(r, e, t, u) {
  u === void 0 && (u = t), r[u] = e[t];
}), Si = O && O.__setModuleDefault || (Object.create ? function(r, e) {
  Object.defineProperty(r, "default", { enumerable: !0, value: e });
} : function(r, e) {
  r.default = e;
}), Ei = O && O.__importStar || function(r) {
  if (r && r.__esModule) return r;
  var e = {};
  if (r != null) for (var t in r) t !== "default" && Object.prototype.hasOwnProperty.call(r, t) && wi(e, r, t);
  return Si(e, r), e;
};
Object.defineProperty(je, "__esModule", { value: !0 });
je.render = void 0;
var te = Ei(Te), at = tr, ir = xe, Ti = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function Ai(r) {
  return r.replace(/"/g, "&quot;");
}
function Oi(r, e) {
  var t;
  if (r) {
    var u = ((t = e.encodeEntities) !== null && t !== void 0 ? t : e.decodeEntities) === !1 ? Ai : e.xmlMode || e.encodeEntities !== "utf8" ? at.encodeXML : at.escapeAttribute;
    return Object.keys(r).map(function(i) {
      var n, o, l = (n = r[i]) !== null && n !== void 0 ? n : "";
      return e.xmlMode === "foreign" && (i = (o = ir.attributeNames.get(i)) !== null && o !== void 0 ? o : i), !e.emptyAttrs && !e.xmlMode && l === "" ? i : "".concat(i, '="').concat(u(l), '"');
    }).join(" ");
  }
}
var yu = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function bt(r, e) {
  e === void 0 && (e = {});
  for (var t = ("length" in r) ? r : [r], u = "", i = 0; i < t.length; i++)
    u += Ni(t[i], e);
  return u;
}
je.render = bt;
je.default = bt;
function Ni(r, e) {
  switch (r.type) {
    case te.Root:
      return bt(r.children, e);
    case te.Doctype:
    case te.Directive:
      return Di(r);
    case te.Comment:
      return Mi(r);
    case te.CDATA:
      return Li(r);
    case te.Script:
    case te.Style:
    case te.Tag:
      return Ci(r, e);
    case te.Text:
      return Pi(r, e);
  }
}
var _i = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), Ii = /* @__PURE__ */ new Set(["svg", "math"]);
function Ci(r, e) {
  var t;
  e.xmlMode === "foreign" && (r.name = (t = ir.elementNames.get(r.name)) !== null && t !== void 0 ? t : r.name, r.parent && _i.has(r.parent.name) && (e = ye(ye({}, e), { xmlMode: !1 }))), !e.xmlMode && Ii.has(r.name) && (e = ye(ye({}, e), { xmlMode: "foreign" }));
  var u = "<".concat(r.name), i = Oi(r.attribs, e);
  return i && (u += " ".concat(i)), r.children.length === 0 && (e.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    e.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    e.selfClosingTags && yu.has(r.name)
  )) ? (e.xmlMode || (u += " "), u += "/>") : (u += ">", r.children.length > 0 && (u += bt(r.children, e)), (e.xmlMode || !yu.has(r.name)) && (u += "</".concat(r.name, ">"))), u;
}
function Di(r) {
  return "<".concat(r.data, ">");
}
function Pi(r, e) {
  var t, u = r.data || "";
  return ((t = e.encodeEntities) !== null && t !== void 0 ? t : e.decodeEntities) !== !1 && !(!e.xmlMode && r.parent && Ti.has(r.parent.name)) && (u = e.xmlMode || e.encodeEntities !== "utf8" ? (0, at.encodeXML)(u) : (0, at.escapeText)(u)), u;
}
function Li(r) {
  return "<![CDATA[".concat(r.children[0].data, "]]>");
}
function Mi(r) {
  return "<!--".concat(r.data, "-->");
}
var Ri = O && O.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(ce, "__esModule", { value: !0 });
ce.getOuterHTML = nr;
ce.getInnerHTML = Bi;
ce.getText = ut;
ce.textContent = _t;
ce.innerText = It;
var Y = re, ki = Ri(je), qi = Te;
function nr(r, e) {
  return (0, ki.default)(r, e);
}
function Bi(r, e) {
  return (0, Y.hasChildren)(r) ? r.children.map(function(t) {
    return nr(t, e);
  }).join("") : "";
}
function ut(r) {
  return Array.isArray(r) ? r.map(ut).join("") : (0, Y.isTag)(r) ? r.name === "br" ? `
` : ut(r.children) : (0, Y.isCDATA)(r) ? ut(r.children) : (0, Y.isText)(r) ? r.data : "";
}
function _t(r) {
  return Array.isArray(r) ? r.map(_t).join("") : (0, Y.hasChildren)(r) && !(0, Y.isComment)(r) ? _t(r.children) : (0, Y.isText)(r) ? r.data : "";
}
function It(r) {
  return Array.isArray(r) ? r.map(It).join("") : (0, Y.hasChildren)(r) && (r.type === qi.ElementType.Tag || (0, Y.isCDATA)(r)) ? It(r.children) : (0, Y.isText)(r) ? r.data : "";
}
var K = {};
Object.defineProperty(K, "__esModule", { value: !0 });
K.getChildren = ar;
K.getParent = sr;
K.getSiblings = ji;
K.getAttributeValue = Ui;
K.hasAttrib = Hi;
K.getName = $i;
K.nextElementSibling = Fi;
K.prevElementSibling = Vi;
var Zt = re;
function ar(r) {
  return (0, Zt.hasChildren)(r) ? r.children : [];
}
function sr(r) {
  return r.parent || null;
}
function ji(r) {
  var e, t, u = sr(r);
  if (u != null)
    return ar(u);
  for (var i = [r], n = r.prev, o = r.next; n != null; )
    i.unshift(n), e = n, n = e.prev;
  for (; o != null; )
    i.push(o), t = o, o = t.next;
  return i;
}
function Ui(r, e) {
  var t;
  return (t = r.attribs) === null || t === void 0 ? void 0 : t[e];
}
function Hi(r, e) {
  return r.attribs != null && Object.prototype.hasOwnProperty.call(r.attribs, e) && r.attribs[e] != null;
}
function $i(r) {
  return r.name;
}
function Fi(r) {
  for (var e, t = r.next; t !== null && !(0, Zt.isTag)(t); )
    e = t, t = e.next;
  return t;
}
function Vi(r) {
  for (var e, t = r.prev; t !== null && !(0, Zt.isTag)(t); )
    e = t, t = e.prev;
  return t;
}
var le = {};
Object.defineProperty(le, "__esModule", { value: !0 });
le.removeElement = Ue;
le.replaceElement = zi;
le.appendChild = Gi;
le.append = Wi;
le.prependChild = Xi;
le.prepend = Qi;
function Ue(r) {
  if (r.prev && (r.prev.next = r.next), r.next && (r.next.prev = r.prev), r.parent) {
    var e = r.parent.children, t = e.lastIndexOf(r);
    t >= 0 && e.splice(t, 1);
  }
  r.next = null, r.prev = null, r.parent = null;
}
function zi(r, e) {
  var t = e.prev = r.prev;
  t && (t.next = e);
  var u = e.next = r.next;
  u && (u.prev = e);
  var i = e.parent = r.parent;
  if (i) {
    var n = i.children;
    n[n.lastIndexOf(r)] = e, r.parent = null;
  }
}
function Gi(r, e) {
  if (Ue(e), e.next = null, e.parent = r, r.children.push(e) > 1) {
    var t = r.children[r.children.length - 2];
    t.next = e, e.prev = t;
  } else
    e.prev = null;
}
function Wi(r, e) {
  Ue(e);
  var t = r.parent, u = r.next;
  if (e.next = u, e.prev = r, r.next = e, e.parent = t, u) {
    if (u.prev = e, t) {
      var i = t.children;
      i.splice(i.lastIndexOf(u), 0, e);
    }
  } else t && t.children.push(e);
}
function Xi(r, e) {
  if (Ue(e), e.parent = r, e.prev = null, r.children.unshift(e) !== 1) {
    var t = r.children[1];
    t.prev = e, e.next = t;
  } else
    e.next = null;
}
function Qi(r, e) {
  Ue(e);
  var t = r.parent;
  if (t) {
    var u = t.children;
    u.splice(u.indexOf(r), 0, e);
  }
  r.prev && (r.prev.next = e), e.parent = t, e.prev = r.prev, e.next = r, r.prev = e;
}
var ne = {};
Object.defineProperty(ne, "__esModule", { value: !0 });
ne.filter = Ji;
ne.find = or;
ne.findOneChild = Zi;
ne.findOne = cr;
ne.existsOne = lr;
ne.findAll = Yi;
var pe = re;
function Ji(r, e, t, u) {
  return t === void 0 && (t = !0), u === void 0 && (u = 1 / 0), or(r, Array.isArray(e) ? e : [e], t, u);
}
function or(r, e, t, u) {
  for (var i = [], n = [Array.isArray(e) ? e : [e]], o = [0]; ; ) {
    if (o[0] >= n[0].length) {
      if (o.length === 1)
        return i;
      n.shift(), o.shift();
      continue;
    }
    var l = n[0][o[0]++];
    if (r(l) && (i.push(l), --u <= 0))
      return i;
    t && (0, pe.hasChildren)(l) && l.children.length > 0 && (o.unshift(0), n.unshift(l.children));
  }
}
function Zi(r, e) {
  return e.find(r);
}
function cr(r, e, t) {
  t === void 0 && (t = !0);
  for (var u = Array.isArray(e) ? e : [e], i = 0; i < u.length; i++) {
    var n = u[i];
    if ((0, pe.isTag)(n) && r(n))
      return n;
    if (t && (0, pe.hasChildren)(n) && n.children.length > 0) {
      var o = cr(r, n.children, !0);
      if (o)
        return o;
    }
  }
  return null;
}
function lr(r, e) {
  return (Array.isArray(e) ? e : [e]).some(function(t) {
    return (0, pe.isTag)(t) && r(t) || (0, pe.hasChildren)(t) && lr(r, t.children);
  });
}
function Yi(r, e) {
  for (var t = [], u = [Array.isArray(e) ? e : [e]], i = [0]; ; ) {
    if (i[0] >= u[0].length) {
      if (u.length === 1)
        return t;
      u.shift(), i.shift();
      continue;
    }
    var n = u[0][i[0]++];
    (0, pe.isTag)(n) && r(n) && t.push(n), (0, pe.hasChildren)(n) && n.children.length > 0 && (i.unshift(0), u.unshift(n.children));
  }
}
var ae = {};
Object.defineProperty(ae, "__esModule", { value: !0 });
ae.testElement = e0;
ae.getElements = t0;
ae.getElementById = u0;
ae.getElementsByTagName = r0;
ae.getElementsByClassName = i0;
ae.getElementsByTagType = n0;
var de = re, He = ne, st = {
  tag_name: function(r) {
    return typeof r == "function" ? function(e) {
      return (0, de.isTag)(e) && r(e.name);
    } : r === "*" ? de.isTag : function(e) {
      return (0, de.isTag)(e) && e.name === r;
    };
  },
  tag_type: function(r) {
    return typeof r == "function" ? function(e) {
      return r(e.type);
    } : function(e) {
      return e.type === r;
    };
  },
  tag_contains: function(r) {
    return typeof r == "function" ? function(e) {
      return (0, de.isText)(e) && r(e.data);
    } : function(e) {
      return (0, de.isText)(e) && e.data === r;
    };
  }
};
function Yt(r, e) {
  return typeof e == "function" ? function(t) {
    return (0, de.isTag)(t) && e(t.attribs[r]);
  } : function(t) {
    return (0, de.isTag)(t) && t.attribs[r] === e;
  };
}
function Ki(r, e) {
  return function(t) {
    return r(t) || e(t);
  };
}
function fr(r) {
  var e = Object.keys(r).map(function(t) {
    var u = r[t];
    return Object.prototype.hasOwnProperty.call(st, t) ? st[t](u) : Yt(t, u);
  });
  return e.length === 0 ? null : e.reduce(Ki);
}
function e0(r, e) {
  var t = fr(r);
  return t ? t(e) : !0;
}
function t0(r, e, t, u) {
  u === void 0 && (u = 1 / 0);
  var i = fr(r);
  return i ? (0, He.filter)(i, e, t, u) : [];
}
function u0(r, e, t) {
  return t === void 0 && (t = !0), Array.isArray(e) || (e = [e]), (0, He.findOne)(Yt("id", r), e, t);
}
function r0(r, e, t, u) {
  return t === void 0 && (t = !0), u === void 0 && (u = 1 / 0), (0, He.filter)(st.tag_name(r), e, t, u);
}
function i0(r, e, t, u) {
  return t === void 0 && (t = !0), u === void 0 && (u = 1 / 0), (0, He.filter)(Yt("class", r), e, t, u);
}
function n0(r, e, t, u) {
  return t === void 0 && (t = !0), u === void 0 && (u = 1 / 0), (0, He.filter)(st.tag_type(r), e, t, u);
}
var be = {};
Object.defineProperty(be, "__esModule", { value: !0 });
be.DocumentPosition = void 0;
be.removeSubsets = a0;
be.compareDocumentPosition = dr;
be.uniqueSort = s0;
var xu = re;
function a0(r) {
  for (var e = r.length; --e >= 0; ) {
    var t = r[e];
    if (e > 0 && r.lastIndexOf(t, e - 1) >= 0) {
      r.splice(e, 1);
      continue;
    }
    for (var u = t.parent; u; u = u.parent)
      if (r.includes(u)) {
        r.splice(e, 1);
        break;
      }
  }
  return r;
}
var Q;
(function(r) {
  r[r.DISCONNECTED = 1] = "DISCONNECTED", r[r.PRECEDING = 2] = "PRECEDING", r[r.FOLLOWING = 4] = "FOLLOWING", r[r.CONTAINS = 8] = "CONTAINS", r[r.CONTAINED_BY = 16] = "CONTAINED_BY";
})(Q || (be.DocumentPosition = Q = {}));
function dr(r, e) {
  var t = [], u = [];
  if (r === e)
    return 0;
  for (var i = (0, xu.hasChildren)(r) ? r : r.parent; i; )
    t.unshift(i), i = i.parent;
  for (i = (0, xu.hasChildren)(e) ? e : e.parent; i; )
    u.unshift(i), i = i.parent;
  for (var n = Math.min(t.length, u.length), o = 0; o < n && t[o] === u[o]; )
    o++;
  if (o === 0)
    return Q.DISCONNECTED;
  var l = t[o - 1], a = l.children, f = t[o], d = u[o];
  return a.indexOf(f) > a.indexOf(d) ? l === e ? Q.FOLLOWING | Q.CONTAINED_BY : Q.FOLLOWING : l === r ? Q.PRECEDING | Q.CONTAINS : Q.PRECEDING;
}
function s0(r) {
  return r = r.filter(function(e, t, u) {
    return !u.includes(e, t + 1);
  }), r.sort(function(e, t) {
    var u = dr(e, t);
    return u & Q.PRECEDING ? -1 : u & Q.FOLLOWING ? 1 : 0;
  }), r;
}
var Kt = {};
Object.defineProperty(Kt, "__esModule", { value: !0 });
Kt.getFeed = c0;
var o0 = ce, $e = ae;
function c0(r) {
  var e = ot(p0, r);
  return e ? e.name === "feed" ? l0(e) : f0(e) : null;
}
function l0(r) {
  var e, t = r.children, u = {
    type: "atom",
    items: (0, $e.getElementsByTagName)("entry", t).map(function(o) {
      var l, a = o.children, f = { media: hr(a) };
      z(f, "id", "id", a), z(f, "title", "title", a);
      var d = (l = ot("link", a)) === null || l === void 0 ? void 0 : l.attribs.href;
      d && (f.link = d);
      var y = se("summary", a) || se("content", a);
      y && (f.description = y);
      var s = se("updated", a);
      return s && (f.pubDate = new Date(s)), f;
    })
  };
  z(u, "id", "id", t), z(u, "title", "title", t);
  var i = (e = ot("link", t)) === null || e === void 0 ? void 0 : e.attribs.href;
  i && (u.link = i), z(u, "description", "subtitle", t);
  var n = se("updated", t);
  return n && (u.updated = new Date(n)), z(u, "author", "email", t, !0), u;
}
function f0(r) {
  var e, t, u = (t = (e = ot("channel", r.children)) === null || e === void 0 ? void 0 : e.children) !== null && t !== void 0 ? t : [], i = {
    type: r.name.substr(0, 3),
    id: "",
    items: (0, $e.getElementsByTagName)("item", r.children).map(function(o) {
      var l = o.children, a = { media: hr(l) };
      z(a, "id", "guid", l), z(a, "title", "title", l), z(a, "link", "link", l), z(a, "description", "description", l);
      var f = se("pubDate", l) || se("dc:date", l);
      return f && (a.pubDate = new Date(f)), a;
    })
  };
  z(i, "title", "title", u), z(i, "link", "link", u), z(i, "description", "description", u);
  var n = se("lastBuildDate", u);
  return n && (i.updated = new Date(n)), z(i, "author", "managingEditor", u, !0), i;
}
var d0 = ["url", "type", "lang"], h0 = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function hr(r) {
  return (0, $e.getElementsByTagName)("media:content", r).map(function(e) {
    for (var t = e.attribs, u = {
      medium: t.medium,
      isDefault: !!t.isDefault
    }, i = 0, n = d0; i < n.length; i++) {
      var o = n[i];
      t[o] && (u[o] = t[o]);
    }
    for (var l = 0, a = h0; l < a.length; l++) {
      var o = a[l];
      t[o] && (u[o] = parseInt(t[o], 10));
    }
    return t.expression && (u.expression = t.expression), u;
  });
}
function ot(r, e) {
  return (0, $e.getElementsByTagName)(r, e, !0, 1)[0];
}
function se(r, e, t) {
  return t === void 0 && (t = !1), (0, o0.textContent)((0, $e.getElementsByTagName)(r, e, t, 1)).trim();
}
function z(r, e, t, u, i) {
  i === void 0 && (i = !1);
  var n = se(t, u, i);
  n && (r[e] = n);
}
function p0(r) {
  return r === "rss" || r === "feed" || r === "rdf:RDF";
}
(function(r) {
  var e = O && O.__createBinding || (Object.create ? function(i, n, o, l) {
    l === void 0 && (l = o);
    var a = Object.getOwnPropertyDescriptor(n, o);
    (!a || ("get" in a ? !n.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
      return n[o];
    } }), Object.defineProperty(i, l, a);
  } : function(i, n, o, l) {
    l === void 0 && (l = o), i[l] = n[o];
  }), t = O && O.__exportStar || function(i, n) {
    for (var o in i) o !== "default" && !Object.prototype.hasOwnProperty.call(n, o) && e(n, i, o);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.hasChildren = r.isDocument = r.isComment = r.isText = r.isCDATA = r.isTag = void 0, t(ce, r), t(K, r), t(le, r), t(ne, r), t(ae, r), t(be, r), t(Kt, r);
  var u = re;
  Object.defineProperty(r, "isTag", { enumerable: !0, get: function() {
    return u.isTag;
  } }), Object.defineProperty(r, "isCDATA", { enumerable: !0, get: function() {
    return u.isCDATA;
  } }), Object.defineProperty(r, "isText", { enumerable: !0, get: function() {
    return u.isText;
  } }), Object.defineProperty(r, "isComment", { enumerable: !0, get: function() {
    return u.isComment;
  } }), Object.defineProperty(r, "isDocument", { enumerable: !0, get: function() {
    return u.isDocument;
  } }), Object.defineProperty(r, "hasChildren", { enumerable: !0, get: function() {
    return u.hasChildren;
  } });
})(tt);
(function(r) {
  var e = O && O.__createBinding || (Object.create ? function(S, N, D, I) {
    I === void 0 && (I = D);
    var R = Object.getOwnPropertyDescriptor(N, D);
    (!R || ("get" in R ? !N.__esModule : R.writable || R.configurable)) && (R = { enumerable: !0, get: function() {
      return N[D];
    } }), Object.defineProperty(S, I, R);
  } : function(S, N, D, I) {
    I === void 0 && (I = D), S[I] = N[D];
  }), t = O && O.__setModuleDefault || (Object.create ? function(S, N) {
    Object.defineProperty(S, "default", { enumerable: !0, value: N });
  } : function(S, N) {
    S.default = N;
  }), u = O && O.__importStar || function(S) {
    if (S && S.__esModule) return S;
    var N = {};
    if (S != null) for (var D in S) D !== "default" && Object.prototype.hasOwnProperty.call(S, D) && e(N, S, D);
    return t(N, S), N;
  }, i = O && O.__importDefault || function(S) {
    return S && S.__esModule ? S : { default: S };
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.DomUtils = r.parseFeed = r.getFeed = r.ElementType = r.Tokenizer = r.createDomStream = r.parseDOM = r.parseDocument = r.DefaultHandler = r.DomHandler = r.Parser = void 0;
  var n = De, o = De;
  Object.defineProperty(r, "Parser", { enumerable: !0, get: function() {
    return o.Parser;
  } });
  var l = re, a = re;
  Object.defineProperty(r, "DomHandler", { enumerable: !0, get: function() {
    return a.DomHandler;
  } }), Object.defineProperty(r, "DefaultHandler", { enumerable: !0, get: function() {
    return a.DomHandler;
  } });
  function f(S, N) {
    var D = new l.DomHandler(void 0, N);
    return new n.Parser(D, N).end(S), D.root;
  }
  r.parseDocument = f;
  function d(S, N) {
    return f(S, N).children;
  }
  r.parseDOM = d;
  function y(S, N, D) {
    var I = new l.DomHandler(S, N, D);
    return new n.Parser(I, N);
  }
  r.createDomStream = y;
  var s = zt;
  Object.defineProperty(r, "Tokenizer", { enumerable: !0, get: function() {
    return i(s).default;
  } }), r.ElementType = u(Te);
  var c = tt, w = tt;
  Object.defineProperty(r, "getFeed", { enumerable: !0, get: function() {
    return w.getFeed;
  } });
  var E = { xmlMode: !0 };
  function b(S, N) {
    return N === void 0 && (N = E), (0, c.getFeed)(d(S, N));
  }
  r.parseFeed = b, r.DomUtils = u(tt);
})($u);
var b0 = (r) => {
  if (typeof r != "string")
    throw new TypeError("Expected a string");
  return r.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}, eu = {};
Object.defineProperty(eu, "__esModule", { value: !0 });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function vu(r) {
  return Object.prototype.toString.call(r) === "[object Object]";
}
function m0(r) {
  var e, t;
  return vu(r) === !1 ? !1 : (e = r.constructor, e === void 0 ? !0 : (t = e.prototype, !(vu(t) === !1 || t.hasOwnProperty("isPrototypeOf") === !1)));
}
eu.isPlainObject = m0;
var g0 = function(e) {
  return y0(e) && !x0(e);
};
function y0(r) {
  return !!r && typeof r == "object";
}
function x0(r) {
  var e = Object.prototype.toString.call(r);
  return e === "[object RegExp]" || e === "[object Date]" || S0(r);
}
var v0 = typeof Symbol == "function" && Symbol.for, w0 = v0 ? Symbol.for("react.element") : 60103;
function S0(r) {
  return r.$$typeof === w0;
}
function E0(r) {
  return Array.isArray(r) ? [] : {};
}
function Le(r, e) {
  return e.clone !== !1 && e.isMergeableObject(r) ? ve(E0(r), r, e) : r;
}
function T0(r, e, t) {
  return r.concat(e).map(function(u) {
    return Le(u, t);
  });
}
function A0(r, e) {
  if (!e.customMerge)
    return ve;
  var t = e.customMerge(r);
  return typeof t == "function" ? t : ve;
}
function O0(r) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(r).filter(function(e) {
    return Object.propertyIsEnumerable.call(r, e);
  }) : [];
}
function wu(r) {
  return Object.keys(r).concat(O0(r));
}
function pr(r, e) {
  try {
    return e in r;
  } catch {
    return !1;
  }
}
function N0(r, e) {
  return pr(r, e) && !(Object.hasOwnProperty.call(r, e) && Object.propertyIsEnumerable.call(r, e));
}
function _0(r, e, t) {
  var u = {};
  return t.isMergeableObject(r) && wu(r).forEach(function(i) {
    u[i] = Le(r[i], t);
  }), wu(e).forEach(function(i) {
    N0(r, i) || (pr(r, i) && t.isMergeableObject(e[i]) ? u[i] = A0(i, t)(r[i], e[i], t) : u[i] = Le(e[i], t));
  }), u;
}
function ve(r, e, t) {
  t = t || {}, t.arrayMerge = t.arrayMerge || T0, t.isMergeableObject = t.isMergeableObject || g0, t.cloneUnlessOtherwiseSpecified = Le;
  var u = Array.isArray(e), i = Array.isArray(r), n = u === i;
  return n ? u ? t.arrayMerge(r, e, t) : _0(r, e, t) : Le(e, t);
}
ve.all = function(e, t) {
  if (!Array.isArray(e))
    throw new Error("first argument should be an array");
  return e.reduce(function(u, i) {
    return ve(u, i, t);
  }, {});
};
var I0 = ve, C0 = I0, br = { exports: {} };
(function(r) {
  (function(e, t) {
    r.exports ? r.exports = t() : e.parseSrcset = t();
  })(O, function() {
    return function(e) {
      function t(I) {
        return I === " " || // space
        I === "	" || // horizontal tab
        I === `
` || // new line
        I === "\f" || // form feed
        I === "\r";
      }
      function u(I) {
        var R, $ = I.exec(e.substring(b));
        if ($)
          return R = $[0], b += R.length, R;
      }
      for (var i = e.length, n = /^[ \t\n\r\u000c]+/, o = /^[, \t\n\r\u000c]+/, l = /^[^ \t\n\r\u000c]+/, a = /[,]+$/, f = /^\d+$/, d = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, y, s, c, w, E, b = 0, S = []; ; ) {
        if (u(o), b >= i)
          return S;
        y = u(l), s = [], y.slice(-1) === "," ? (y = y.replace(a, ""), D()) : N();
      }
      function N() {
        for (u(n), c = "", w = "in descriptor"; ; ) {
          if (E = e.charAt(b), w === "in descriptor")
            if (t(E))
              c && (s.push(c), c = "", w = "after descriptor");
            else if (E === ",") {
              b += 1, c && s.push(c), D();
              return;
            } else if (E === "(")
              c = c + E, w = "in parens";
            else if (E === "") {
              c && s.push(c), D();
              return;
            } else
              c = c + E;
          else if (w === "in parens")
            if (E === ")")
              c = c + E, w = "in descriptor";
            else if (E === "") {
              s.push(c), D();
              return;
            } else
              c = c + E;
          else if (w === "after descriptor" && !t(E))
            if (E === "") {
              D();
              return;
            } else
              w = "in descriptor", b -= 1;
          b += 1;
        }
      }
      function D() {
        var I = !1, R, $, W, H, F = {}, V, p, x, v, A;
        for (H = 0; H < s.length; H++)
          V = s[H], p = V[V.length - 1], x = V.substring(0, V.length - 1), v = parseInt(x, 10), A = parseFloat(x), f.test(x) && p === "w" ? ((R || $) && (I = !0), v === 0 ? I = !0 : R = v) : d.test(x) && p === "x" ? ((R || $ || W) && (I = !0), A < 0 ? I = !0 : $ = A) : f.test(x) && p === "h" ? ((W || $) && (I = !0), v === 0 ? I = !0 : W = v) : I = !0;
        I ? console && console.log && console.log("Invalid srcset descriptor found in '" + e + "' at '" + V + "'.") : (F.url = y, R && (F.w = R), $ && (F.d = $), W && (F.h = W), S.push(F));
      }
    };
  });
})(br);
var D0 = br.exports, tu = { exports: {} }, _ = String, mr = function() {
  return { isColorSupported: !1, reset: _, bold: _, dim: _, italic: _, underline: _, inverse: _, hidden: _, strikethrough: _, black: _, red: _, green: _, yellow: _, blue: _, magenta: _, cyan: _, white: _, gray: _, bgBlack: _, bgRed: _, bgGreen: _, bgYellow: _, bgBlue: _, bgMagenta: _, bgCyan: _, bgWhite: _, blackBright: _, redBright: _, greenBright: _, yellowBright: _, blueBright: _, magentaBright: _, cyanBright: _, whiteBright: _, bgBlackBright: _, bgRedBright: _, bgGreenBright: _, bgYellowBright: _, bgBlueBright: _, bgMagentaBright: _, bgCyanBright: _, bgWhiteBright: _ };
};
tu.exports = mr();
tu.exports.createColors = mr;
var P0 = tu.exports;
const L0 = {}, M0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: L0
}, Symbol.toStringTag, { value: "Module" })), J = /* @__PURE__ */ ai(M0);
let Su = P0, Eu = J, Ct = class gr extends Error {
  constructor(e, t, u, i, n, o) {
    super(e), this.name = "CssSyntaxError", this.reason = e, n && (this.file = n), i && (this.source = i), o && (this.plugin = o), typeof t < "u" && typeof u < "u" && (typeof t == "number" ? (this.line = t, this.column = u) : (this.line = t.line, this.column = t.column, this.endLine = u.line, this.endColumn = u.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, gr);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(e) {
    if (!this.source) return "";
    let t = this.source;
    e == null && (e = Su.isColorSupported);
    let u = (d) => d, i = (d) => d, n = (d) => d;
    if (e) {
      let { bold: d, gray: y, red: s } = Su.createColors(!0);
      i = (c) => d(s(c)), u = (c) => y(c), Eu && (n = (c) => Eu(c));
    }
    let o = t.split(/\r?\n/), l = Math.max(this.line - 3, 0), a = Math.min(this.line + 2, o.length), f = String(a).length;
    return o.slice(l, a).map((d, y) => {
      let s = l + 1 + y, c = " " + (" " + s).slice(-f) + " | ";
      if (s === this.line) {
        if (d.length > 160) {
          let E = 20, b = Math.max(0, this.column - E), S = Math.max(
            this.column + E,
            this.endColumn + E
          ), N = d.slice(b, S), D = u(c.replace(/\d/g, " ")) + d.slice(0, Math.min(this.column - 1, E - 1)).replace(/[^\t]/g, " ");
          return i(">") + u(c) + n(N) + `
 ` + D + i("^");
        }
        let w = u(c.replace(/\d/g, " ")) + d.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return i(">") + u(c) + n(d) + `
 ` + w + i("^");
      }
      return " " + u(c) + n(d);
    }).join(`
`);
  }
  toString() {
    let e = this.showSourceCode();
    return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
  }
};
var uu = Ct;
Ct.default = Ct;
const Tu = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function R0(r) {
  return r[0].toUpperCase() + r.slice(1);
}
let Dt = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, t) {
    let u = "@" + e.name, i = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName < "u" ? u += e.raws.afterName : i && (u += " "), e.nodes)
      this.block(e, u + i);
    else {
      let n = (e.raws.between || "") + (t ? ";" : "");
      this.builder(u + i + n, e);
    }
  }
  beforeAfter(e, t) {
    let u;
    e.type === "decl" ? u = this.raw(e, null, "beforeDecl") : e.type === "comment" ? u = this.raw(e, null, "beforeComment") : t === "before" ? u = this.raw(e, null, "beforeRule") : u = this.raw(e, null, "beforeClose");
    let i = e.parent, n = 0;
    for (; i && i.type !== "root"; )
      n += 1, i = i.parent;
    if (u.includes(`
`)) {
      let o = this.raw(e, null, "indent");
      if (o.length)
        for (let l = 0; l < n; l++) u += o;
    }
    return u;
  }
  block(e, t) {
    let u = this.raw(e, "between", "beforeOpen");
    this.builder(t + u + "{", e, "start");
    let i;
    e.nodes && e.nodes.length ? (this.body(e), i = this.raw(e, "after")) : i = this.raw(e, "after", "emptyBody"), i && this.builder(i), this.builder("}", e, "end");
  }
  body(e) {
    let t = e.nodes.length - 1;
    for (; t > 0 && e.nodes[t].type === "comment"; )
      t -= 1;
    let u = this.raw(e, "semicolon");
    for (let i = 0; i < e.nodes.length; i++) {
      let n = e.nodes[i], o = this.raw(n, "before");
      o && this.builder(o), this.stringify(n, t !== i || u);
    }
  }
  comment(e) {
    let t = this.raw(e, "left", "commentLeft"), u = this.raw(e, "right", "commentRight");
    this.builder("/*" + t + e.text + u + "*/", e);
  }
  decl(e, t) {
    let u = this.raw(e, "between", "colon"), i = e.prop + u + this.rawValue(e, "value");
    e.important && (i += e.raws.important || " !important"), t && (i += ";"), this.builder(i, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, t, u) {
    let i;
    if (u || (u = t), t && (i = e.raws[t], typeof i < "u"))
      return i;
    let n = e.parent;
    if (u === "before" && (!n || n.type === "root" && n.first === e || n && n.type === "document"))
      return "";
    if (!n) return Tu[u];
    let o = e.root();
    if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[u] < "u")
      return o.rawCache[u];
    if (u === "before" || u === "after")
      return this.beforeAfter(e, u);
    {
      let l = "raw" + R0(u);
      this[l] ? i = this[l](o, e) : o.walk((a) => {
        if (i = a.raws[t], typeof i < "u") return !1;
      });
    }
    return typeof i > "u" && (i = Tu[u]), o.rawCache[u] = i, i;
  }
  rawBeforeClose(e) {
    let t;
    return e.walk((u) => {
      if (u.nodes && u.nodes.length > 0 && typeof u.raws.after < "u")
        return t = u.raws.after, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeComment(e, t) {
    let u;
    return e.walkComments((i) => {
      if (typeof i.raws.before < "u")
        return u = i.raws.before, u.includes(`
`) && (u = u.replace(/[^\n]+$/, "")), !1;
    }), typeof u > "u" ? u = this.raw(t, null, "beforeDecl") : u && (u = u.replace(/\S/g, "")), u;
  }
  rawBeforeDecl(e, t) {
    let u;
    return e.walkDecls((i) => {
      if (typeof i.raws.before < "u")
        return u = i.raws.before, u.includes(`
`) && (u = u.replace(/[^\n]+$/, "")), !1;
    }), typeof u > "u" ? u = this.raw(t, null, "beforeRule") : u && (u = u.replace(/\S/g, "")), u;
  }
  rawBeforeOpen(e) {
    let t;
    return e.walk((u) => {
      if (u.type !== "decl" && (t = u.raws.between, typeof t < "u"))
        return !1;
    }), t;
  }
  rawBeforeRule(e) {
    let t;
    return e.walk((u) => {
      if (u.nodes && (u.parent !== e || e.first !== u) && typeof u.raws.before < "u")
        return t = u.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawColon(e) {
    let t;
    return e.walkDecls((u) => {
      if (typeof u.raws.between < "u")
        return t = u.raws.between.replace(/[^\s:]/g, ""), !1;
    }), t;
  }
  rawEmptyBody(e) {
    let t;
    return e.walk((u) => {
      if (u.nodes && u.nodes.length === 0 && (t = u.raws.after, typeof t < "u"))
        return !1;
    }), t;
  }
  rawIndent(e) {
    if (e.raws.indent) return e.raws.indent;
    let t;
    return e.walk((u) => {
      let i = u.parent;
      if (i && i !== e && i.parent && i.parent === e && typeof u.raws.before < "u") {
        let n = u.raws.before.split(`
`);
        return t = n[n.length - 1], t = t.replace(/\S/g, ""), !1;
      }
    }), t;
  }
  rawSemicolon(e) {
    let t;
    return e.walk((u) => {
      if (u.nodes && u.nodes.length && u.last.type === "decl" && (t = u.raws.semicolon, typeof t < "u"))
        return !1;
    }), t;
  }
  rawValue(e, t) {
    let u = e[t], i = e.raws[t];
    return i && i.value === u ? i.raw : u;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, t) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, t);
  }
};
var yr = Dt;
Dt.default = Dt;
let k0 = yr;
function Pt(r, e) {
  new k0(e).stringify(r);
}
var mt = Pt;
Pt.default = Pt;
var Fe = {};
Fe.isClean = Symbol("isClean");
Fe.my = Symbol("my");
let q0 = uu, B0 = yr, j0 = mt, { isClean: Ae, my: U0 } = Fe;
function Lt(r, e) {
  let t = new r.constructor();
  for (let u in r) {
    if (!Object.prototype.hasOwnProperty.call(r, u) || u === "proxyCache") continue;
    let i = r[u], n = typeof i;
    u === "parent" && n === "object" ? e && (t[u] = e) : u === "source" ? t[u] = i : Array.isArray(i) ? t[u] = i.map((o) => Lt(o, t)) : (n === "object" && i !== null && (i = Lt(i)), t[u] = i);
  }
  return t;
}
function Oe(r, e) {
  if (e && typeof e.offset < "u")
    return e.offset;
  let t = 1, u = 1, i = 0;
  for (let n = 0; n < r.length; n++) {
    if (u === e.line && t === e.column) {
      i = n;
      break;
    }
    r[n] === `
` ? (t = 1, u += 1) : t += 1;
  }
  return i;
}
let Mt = class {
  get proxyOf() {
    return this;
  }
  constructor(e = {}) {
    this.raws = {}, this[Ae] = !1, this[U0] = !0;
    for (let t in e)
      if (t === "nodes") {
        this.nodes = [];
        for (let u of e[t])
          typeof u.clone == "function" ? this.append(u.clone()) : this.append(u);
      } else
        this[t] = e[t];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let t = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let t in e)
      this[t] = e[t];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let t = Lt(this);
    for (let u in e)
      t[u] = e[u];
    return t;
  }
  cloneAfter(e = {}) {
    let t = this.clone(e);
    return this.parent.insertAfter(this, t), t;
  }
  cloneBefore(e = {}) {
    let t = this.clone(e);
    return this.parent.insertBefore(this, t), t;
  }
  error(e, t = {}) {
    if (this.source) {
      let { end: u, start: i } = this.rangeBy(t);
      return this.source.input.error(
        e,
        { column: i.column, line: i.line },
        { column: u.column, line: u.line },
        t
      );
    }
    return new q0(e);
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
      },
      set(e, t, u) {
        return e[t] === u || (e[t] = u, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
        t === "text") && e.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[Ae] = !0;
  }
  markDirty() {
    if (this[Ae]) {
      this[Ae] = !1;
      let e = this;
      for (; e = e.parent; )
        e[Ae] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e) {
    let t = this.source.start;
    if (e.index)
      t = this.positionInside(e.index);
    else if (e.word) {
      let u = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = u.slice(
        Oe(u, this.source.start),
        Oe(u, this.source.end)
      ).indexOf(e.word);
      n !== -1 && (t = this.positionInside(n));
    }
    return t;
  }
  positionInside(e) {
    let t = this.source.start.column, u = this.source.start.line, i = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = Oe(i, this.source.start), o = n + e;
    for (let l = n; l < o; l++)
      i[l] === `
` ? (t = 1, u += 1) : t += 1;
    return { column: t, line: u };
  }
  prev() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e) {
    let t = {
      column: this.source.start.column,
      line: this.source.start.line
    }, u = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: t.column + 1,
      line: t.line
    };
    if (e.word) {
      let i = "document" in this.source.input ? this.source.input.document : this.source.input.css, o = i.slice(
        Oe(i, this.source.start),
        Oe(i, this.source.end)
      ).indexOf(e.word);
      o !== -1 && (t = this.positionInside(o), u = this.positionInside(
        o + e.word.length
      ));
    } else
      e.start ? t = {
        column: e.start.column,
        line: e.start.line
      } : e.index && (t = this.positionInside(e.index)), e.end ? u = {
        column: e.end.column,
        line: e.end.line
      } : typeof e.endIndex == "number" ? u = this.positionInside(e.endIndex) : e.index && (u = this.positionInside(e.index + 1));
    return (u.line < t.line || u.line === t.line && u.column <= t.column) && (u = { column: t.column + 1, line: t.line }), { end: u, start: t };
  }
  raw(e, t) {
    return new B0().raw(this, e, t);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let t = this, u = !1;
      for (let i of e)
        i === this ? u = !0 : u ? (this.parent.insertAfter(t, i), t = i) : this.parent.insertBefore(t, i);
      u || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, t) {
    let u = {}, i = t == null;
    t = t || /* @__PURE__ */ new Map();
    let n = 0;
    for (let o in this) {
      if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache") continue;
      let l = this[o];
      if (Array.isArray(l))
        u[o] = l.map((a) => typeof a == "object" && a.toJSON ? a.toJSON(null, t) : a);
      else if (typeof l == "object" && l.toJSON)
        u[o] = l.toJSON(null, t);
      else if (o === "source") {
        let a = t.get(l.input);
        a == null && (a = n, t.set(l.input, n), n++), u[o] = {
          end: l.end,
          inputId: a,
          start: l.start
        };
      } else
        u[o] = l;
    }
    return i && (u.inputs = [...t.keys()].map((o) => o.toJSON())), u;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = j0) {
    e.stringify && (e = e.stringify);
    let t = "";
    return e(this, (u) => {
      t += u;
    }), t;
  }
  warn(e, t, u) {
    let i = { node: this };
    for (let n in u) i[n] = u[n];
    return e.warn(t, i);
  }
};
var gt = Mt;
Mt.default = Mt;
let H0 = gt, Rt = class extends H0 {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var yt = Rt;
Rt.default = Rt;
let $0 = gt, kt = class extends $0 {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(e) {
    e && typeof e.value < "u" && typeof e.value != "string" && (e = { ...e, value: String(e.value) }), super(e), this.type = "decl";
  }
};
var xt = kt;
kt.default = kt;
let xr = yt, vr = xt, F0 = gt, { isClean: wr, my: Sr } = Fe, ru, Er, Tr, iu;
function Ar(r) {
  return r.map((e) => (e.nodes && (e.nodes = Ar(e.nodes)), delete e.source, e));
}
function Or(r) {
  if (r[wr] = !1, r.proxyOf.nodes)
    for (let e of r.proxyOf.nodes)
      Or(e);
}
let ie = class Nr extends F0 {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...e) {
    for (let t of e) {
      let u = this.normalize(t, this.last);
      for (let i of u) this.proxyOf.nodes.push(i);
    }
    return this.markDirty(), this;
  }
  cleanRaws(e) {
    if (super.cleanRaws(e), this.nodes)
      for (let t of this.nodes) t.cleanRaws(e);
  }
  each(e) {
    if (!this.proxyOf.nodes) return;
    let t = this.getIterator(), u, i;
    for (; this.indexes[t] < this.proxyOf.nodes.length && (u = this.indexes[t], i = e(this.proxyOf.nodes[u], u), i !== !1); )
      this.indexes[t] += 1;
    return delete this.indexes[t], i;
  }
  every(e) {
    return this.nodes.every(e);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let e = this.lastEach;
    return this.indexes[e] = 0, e;
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : e[t] ? t === "each" || typeof t == "string" && t.startsWith("walk") ? (...u) => e[t](
          ...u.map((i) => typeof i == "function" ? (n, o) => i(n.toProxy(), o) : i)
        ) : t === "every" || t === "some" ? (u) => e[t](
          (i, ...n) => u(i.toProxy(), ...n)
        ) : t === "root" ? () => e.root().toProxy() : t === "nodes" ? e.nodes.map((u) => u.toProxy()) : t === "first" || t === "last" ? e[t].toProxy() : e[t] : e[t];
      },
      set(e, t, u) {
        return e[t] === u || (e[t] = u, (t === "name" || t === "params" || t === "selector") && e.markDirty()), !0;
      }
    };
  }
  index(e) {
    return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
  }
  insertAfter(e, t) {
    let u = this.index(e), i = this.normalize(t, this.proxyOf.nodes[u]).reverse();
    u = this.index(e);
    for (let o of i) this.proxyOf.nodes.splice(u + 1, 0, o);
    let n;
    for (let o in this.indexes)
      n = this.indexes[o], u < n && (this.indexes[o] = n + i.length);
    return this.markDirty(), this;
  }
  insertBefore(e, t) {
    let u = this.index(e), i = u === 0 ? "prepend" : !1, n = this.normalize(
      t,
      this.proxyOf.nodes[u],
      i
    ).reverse();
    u = this.index(e);
    for (let l of n) this.proxyOf.nodes.splice(u, 0, l);
    let o;
    for (let l in this.indexes)
      o = this.indexes[l], u <= o && (this.indexes[l] = o + n.length);
    return this.markDirty(), this;
  }
  normalize(e, t) {
    if (typeof e == "string")
      e = Ar(Er(e).nodes);
    else if (typeof e > "u")
      e = [];
    else if (Array.isArray(e)) {
      e = e.slice(0);
      for (let i of e)
        i.parent && i.parent.removeChild(i, "ignore");
    } else if (e.type === "root" && this.type !== "document") {
      e = e.nodes.slice(0);
      for (let i of e)
        i.parent && i.parent.removeChild(i, "ignore");
    } else if (e.type)
      e = [e];
    else if (e.prop) {
      if (typeof e.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof e.value != "string" && (e.value = String(e.value)), e = [new vr(e)];
    } else if (e.selector || e.selectors)
      e = [new iu(e)];
    else if (e.name)
      e = [new ru(e)];
    else if (e.text)
      e = [new xr(e)];
    else
      throw new Error("Unknown node type in node creation");
    return e.map((i) => (i[Sr] || Nr.rebuild(i), i = i.proxyOf, i.parent && i.parent.removeChild(i), i[wr] && Or(i), i.raws || (i.raws = {}), typeof i.raws.before > "u" && t && typeof t.raws.before < "u" && (i.raws.before = t.raws.before.replace(/\S/g, "")), i.parent = this.proxyOf, i));
  }
  prepend(...e) {
    e = e.reverse();
    for (let t of e) {
      let u = this.normalize(t, this.first, "prepend").reverse();
      for (let i of u) this.proxyOf.nodes.unshift(i);
      for (let i in this.indexes)
        this.indexes[i] = this.indexes[i] + u.length;
    }
    return this.markDirty(), this;
  }
  push(e) {
    return e.parent = this, this.proxyOf.nodes.push(e), this;
  }
  removeAll() {
    for (let e of this.proxyOf.nodes) e.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(e) {
    e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
    let t;
    for (let u in this.indexes)
      t = this.indexes[u], t >= e && (this.indexes[u] = t - 1);
    return this.markDirty(), this;
  }
  replaceValues(e, t, u) {
    return u || (u = t, t = {}), this.walkDecls((i) => {
      t.props && !t.props.includes(i.prop) || t.fast && !i.value.includes(t.fast) || (i.value = i.value.replace(e, u));
    }), this.markDirty(), this;
  }
  some(e) {
    return this.nodes.some(e);
  }
  walk(e) {
    return this.each((t, u) => {
      let i;
      try {
        i = e(t, u);
      } catch (n) {
        throw t.addToError(n);
      }
      return i !== !1 && t.walk && (i = t.walk(e)), i;
    });
  }
  walkAtRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((u, i) => {
      if (u.type === "atrule" && e.test(u.name))
        return t(u, i);
    }) : this.walk((u, i) => {
      if (u.type === "atrule" && u.name === e)
        return t(u, i);
    }) : (t = e, this.walk((u, i) => {
      if (u.type === "atrule")
        return t(u, i);
    }));
  }
  walkComments(e) {
    return this.walk((t, u) => {
      if (t.type === "comment")
        return e(t, u);
    });
  }
  walkDecls(e, t) {
    return t ? e instanceof RegExp ? this.walk((u, i) => {
      if (u.type === "decl" && e.test(u.prop))
        return t(u, i);
    }) : this.walk((u, i) => {
      if (u.type === "decl" && u.prop === e)
        return t(u, i);
    }) : (t = e, this.walk((u, i) => {
      if (u.type === "decl")
        return t(u, i);
    }));
  }
  walkRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((u, i) => {
      if (u.type === "rule" && e.test(u.selector))
        return t(u, i);
    }) : this.walk((u, i) => {
      if (u.type === "rule" && u.selector === e)
        return t(u, i);
    }) : (t = e, this.walk((u, i) => {
      if (u.type === "rule")
        return t(u, i);
    }));
  }
};
ie.registerParse = (r) => {
  Er = r;
};
ie.registerRule = (r) => {
  iu = r;
};
ie.registerAtRule = (r) => {
  ru = r;
};
ie.registerRoot = (r) => {
  Tr = r;
};
var me = ie;
ie.default = ie;
ie.rebuild = (r) => {
  r.type === "atrule" ? Object.setPrototypeOf(r, ru.prototype) : r.type === "rule" ? Object.setPrototypeOf(r, iu.prototype) : r.type === "decl" ? Object.setPrototypeOf(r, vr.prototype) : r.type === "comment" ? Object.setPrototypeOf(r, xr.prototype) : r.type === "root" && Object.setPrototypeOf(r, Tr.prototype), r[Sr] = !0, r.nodes && r.nodes.forEach((e) => {
    ie.rebuild(e);
  });
};
let _r = me, ct = class extends _r {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var nu = ct;
ct.default = ct;
_r.registerAtRule(ct);
let V0 = me, Ir, Cr, Me = class extends V0 {
  constructor(e) {
    super({ type: "document", ...e }), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new Ir(new Cr(), this, e).stringify();
  }
};
Me.registerLazyResult = (r) => {
  Ir = r;
};
Me.registerProcessor = (r) => {
  Cr = r;
};
var au = Me;
Me.default = Me;
let z0 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", G0 = (r = 21) => {
  let e = "", t = r | 0;
  for (; t--; )
    e += z0[Math.random() * 64 | 0];
  return e;
};
var W0 = { nanoid: G0 };
let { existsSync: X0, readFileSync: Q0 } = J, { dirname: Et, join: J0 } = J, { SourceMapConsumer: Au, SourceMapGenerator: Ou } = J;
function Z0(r) {
  return Buffer ? Buffer.from(r, "base64").toString() : window.atob(r);
}
let qt = class {
  constructor(e, t) {
    if (t.map === !1) return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let u = t.map ? t.map.prev : void 0, i = this.loadMap(t.from, u);
    !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = Et(this.mapFile)), i && (this.text = i);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new Au(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let t = /^data:application\/json;charset=utf-?8;base64,/, u = /^data:application\/json;base64,/, i = /^data:application\/json;charset=utf-?8,/, n = /^data:application\/json,/, o = e.match(i) || e.match(n);
    if (o)
      return decodeURIComponent(e.substr(o[0].length));
    let l = e.match(t) || e.match(u);
    if (l)
      return Z0(e.substr(l[0].length));
    let a = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + a);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let t = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!t) return;
    let u = e.lastIndexOf(t.pop()), i = e.indexOf("*/", u);
    u > -1 && i > -1 && (this.annotation = this.getAnnotationURL(e.substring(u, i)));
  }
  loadFile(e) {
    if (this.root = Et(e), X0(e))
      return this.mapFile = e, Q0(e, "utf-8").toString().trim();
  }
  loadMap(e, t) {
    if (t === !1) return !1;
    if (t) {
      if (typeof t == "string")
        return t;
      if (typeof t == "function") {
        let u = t(e);
        if (u) {
          let i = this.loadFile(u);
          if (!i)
            throw new Error(
              "Unable to load previous source map: " + u.toString()
            );
          return i;
        }
      } else {
        if (t instanceof Au)
          return Ou.fromSourceMap(t).toString();
        if (t instanceof Ou)
          return t.toString();
        if (this.isMap(t))
          return JSON.stringify(t);
        throw new Error(
          "Unsupported previous source map format: " + t.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let u = this.annotation;
        return e && (u = J0(Et(e), u)), this.loadFile(u);
      }
    }
  }
  startWith(e, t) {
    return e ? e.substr(0, t.length) === t : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var Dr = qt;
qt.default = qt;
let { nanoid: Y0 } = W0, { isAbsolute: Bt, resolve: jt } = J, { SourceMapConsumer: K0, SourceMapGenerator: en } = J, { fileURLToPath: Nu, pathToFileURL: We } = J, _u = uu, tn = Dr, Tt = J, At = Symbol("fromOffsetCache"), un = !!(K0 && en), Iu = !!(jt && Bt), lt = class {
  get from() {
    return this.file || this.id;
  }
  constructor(e, t = {}) {
    if (e === null || typeof e > "u" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, t.document && (this.document = t.document.toString()), t.from && (!Iu || /^\w+:\/\//.test(t.from) || Bt(t.from) ? this.file = t.from : this.file = jt(t.from)), Iu && un) {
      let u = new tn(this.css, t);
      if (u.text) {
        this.map = u;
        let i = u.consumer().file;
        !this.file && i && (this.file = this.mapResolve(i));
      }
    }
    this.file || (this.id = "<input css " + Y0(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, t, u, i = {}) {
    let n, o, l;
    if (t && typeof t == "object") {
      let f = t, d = u;
      if (typeof f.offset == "number") {
        let y = this.fromOffset(f.offset);
        t = y.line, u = y.col;
      } else
        t = f.line, u = f.column;
      if (typeof d.offset == "number") {
        let y = this.fromOffset(d.offset);
        o = y.line, n = y.col;
      } else
        o = d.line, n = d.column;
    } else if (!u) {
      let f = this.fromOffset(t);
      t = f.line, u = f.col;
    }
    let a = this.origin(t, u, o, n);
    return a ? l = new _u(
      e,
      a.endLine === void 0 ? a.line : { column: a.column, line: a.line },
      a.endLine === void 0 ? a.column : { column: a.endColumn, line: a.endLine },
      a.source,
      a.file,
      i.plugin
    ) : l = new _u(
      e,
      o === void 0 ? t : { column: u, line: t },
      o === void 0 ? u : { column: n, line: o },
      this.css,
      this.file,
      i.plugin
    ), l.input = { column: u, endColumn: n, endLine: o, line: t, source: this.css }, this.file && (We && (l.input.url = We(this.file).toString()), l.input.file = this.file), l;
  }
  fromOffset(e) {
    let t, u;
    if (this[At])
      u = this[At];
    else {
      let n = this.css.split(`
`);
      u = new Array(n.length);
      let o = 0;
      for (let l = 0, a = n.length; l < a; l++)
        u[l] = o, o += n[l].length + 1;
      this[At] = u;
    }
    t = u[u.length - 1];
    let i = 0;
    if (e >= t)
      i = u.length - 1;
    else {
      let n = u.length - 2, o;
      for (; i < n; )
        if (o = i + (n - i >> 1), e < u[o])
          n = o - 1;
        else if (e >= u[o + 1])
          i = o + 1;
        else {
          i = o;
          break;
        }
    }
    return {
      col: e - u[i] + 1,
      line: i + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : jt(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, t, u, i) {
    if (!this.map) return !1;
    let n = this.map.consumer(), o = n.originalPositionFor({ column: t, line: e });
    if (!o.source) return !1;
    let l;
    typeof u == "number" && (l = n.originalPositionFor({ column: i, line: u }));
    let a;
    Bt(o.source) ? a = We(o.source) : a = new URL(
      o.source,
      this.map.consumer().sourceRoot || We(this.map.mapFile)
    );
    let f = {
      column: o.column,
      endColumn: l && l.column,
      endLine: l && l.line,
      line: o.line,
      url: a.toString()
    };
    if (a.protocol === "file:")
      if (Nu)
        f.file = Nu(a);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let d = n.sourceContentFor(o.source);
    return d && (f.source = d), f;
  }
  toJSON() {
    let e = {};
    for (let t of ["hasBOM", "css", "file", "id"])
      this[t] != null && (e[t] = this[t]);
    return this.map && (e.map = { ...this.map }, e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
};
var vt = lt;
lt.default = lt;
Tt && Tt.registerInput && Tt.registerInput(lt);
let Pr = me, Lr, Mr, we = class extends Pr {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, t, u) {
    let i = super.normalize(e);
    if (t) {
      if (u === "prepend")
        this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;
      else if (this.first !== t)
        for (let n of i)
          n.raws.before = t.raws.before;
    }
    return i;
  }
  removeChild(e, t) {
    let u = this.index(e);
    return !t && u === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[u].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new Lr(new Mr(), this, e).stringify();
  }
};
we.registerLazyResult = (r) => {
  Lr = r;
};
we.registerProcessor = (r) => {
  Mr = r;
};
var Ve = we;
we.default = we;
Pr.registerRoot(we);
let Re = {
  comma(r) {
    return Re.split(r, [","], !0);
  },
  space(r) {
    let e = [" ", `
`, "	"];
    return Re.split(r, e);
  },
  split(r, e, t) {
    let u = [], i = "", n = !1, o = 0, l = !1, a = "", f = !1;
    for (let d of r)
      f ? f = !1 : d === "\\" ? f = !0 : l ? d === a && (l = !1) : d === '"' || d === "'" ? (l = !0, a = d) : d === "(" ? o += 1 : d === ")" ? o > 0 && (o -= 1) : o === 0 && e.includes(d) && (n = !0), n ? (i !== "" && u.push(i.trim()), i = "", n = !1) : i += d;
    return (t || i !== "") && u.push(i.trim()), u;
  }
};
var Rr = Re;
Re.default = Re;
let kr = me, rn = Rr, ft = class extends kr {
  get selectors() {
    return rn.comma(this.selector);
  }
  set selectors(e) {
    let t = this.selector ? this.selector.match(/,\s*/) : null, u = t ? t[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(u);
  }
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var su = ft;
ft.default = ft;
kr.registerRule(ft);
let nn = nu, an = yt, sn = xt, on = vt, cn = Dr, ln = Ve, fn = su;
function ke(r, e) {
  if (Array.isArray(r)) return r.map((i) => ke(i));
  let { inputs: t, ...u } = r;
  if (t) {
    e = [];
    for (let i of t) {
      let n = { ...i, __proto__: on.prototype };
      n.map && (n.map = {
        ...n.map,
        __proto__: cn.prototype
      }), e.push(n);
    }
  }
  if (u.nodes && (u.nodes = r.nodes.map((i) => ke(i, e))), u.source) {
    let { inputId: i, ...n } = u.source;
    u.source = n, i != null && (u.source.input = e[i]);
  }
  if (u.type === "root")
    return new ln(u);
  if (u.type === "decl")
    return new sn(u);
  if (u.type === "rule")
    return new fn(u);
  if (u.type === "comment")
    return new an(u);
  if (u.type === "atrule")
    return new nn(u);
  throw new Error("Unknown node type: " + r.type);
}
var dn = ke;
ke.default = ke;
let { dirname: rt, relative: qr, resolve: Br, sep: jr } = J, { SourceMapConsumer: Ur, SourceMapGenerator: it } = J, { pathToFileURL: Cu } = J, hn = vt, pn = !!(Ur && it), bn = !!(rt && Br && qr && jr), mn = class {
  constructor(e, t, u, i) {
    this.stringify = e, this.mapOpts = u.map || {}, this.root = t, this.opts = u, this.css = i, this.originalCSS = i, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let t = `
`;
    this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let t = this.toUrl(this.path(e.file)), u = e.root || rt(e.file), i;
      this.mapOpts.sourcesContent === !1 ? (i = new Ur(e.text), i.sourcesContent && (i.sourcesContent = null)) : i = e.consumer(), this.map.applySourceMap(i, t, this.toUrl(this.path(u)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let t = this.root.nodes.length - 1; t >= 0; t--)
          e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
      } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), bn && pn && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (t) => {
        e += t;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = it.fromSourceMap(e, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new it({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new it({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let e = 1, t = 1, u = "<no source>", i = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, n, o;
    this.stringify(this.root, (l, a, f) => {
      if (this.css += l, a && f !== "end" && (i.generated.line = e, i.generated.column = t - 1, a.source && a.source.start ? (i.source = this.sourcePath(a), i.original.line = a.source.start.line, i.original.column = a.source.start.column - 1, this.map.addMapping(i)) : (i.source = u, i.original.line = 1, i.original.column = 0, this.map.addMapping(i))), o = l.match(/\n/g), o ? (e += o.length, n = l.lastIndexOf(`
`), t = l.length - n) : t += l.length, a && f !== "start") {
        let d = a.parent || { raws: {} };
        (!(a.type === "decl" || a.type === "atrule" && !a.nodes) || a !== d.last || d.raws.semicolon) && (a.source && a.source.end ? (i.source = this.sourcePath(a), i.original.line = a.source.end.line, i.original.column = a.source.end.column - 1, i.generated.line = e, i.generated.column = t - 2, this.map.addMapping(i)) : (i.source = u, i.original.line = 1, i.original.column = 0, i.generated.line = e, i.generated.column = t - 1, this.map.addMapping(i)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e < "u" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
    let t = this.memoizedPaths.get(e);
    if (t) return t;
    let u = this.opts.to ? rt(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (u = rt(Br(u, this.mapOpts.annotation)));
    let i = qr(u, e);
    return this.memoizedPaths.set(e, i), i;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let t = e.source.input.map;
            this.previousMaps.includes(t) || this.previousMaps.push(t);
          }
        });
      else {
        let e = new hn(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((t) => {
        if (t.source) {
          let u = t.source.input.from;
          if (u && !e[u]) {
            e[u] = !0;
            let i = this.usesFileUrls ? this.toFileUrl(u) : this.toUrl(this.path(u));
            this.map.setSourceContent(i, t.source.input.css);
          }
        }
      });
    else if (this.css) {
      let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(t, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let t = this.memoizedFileURLs.get(e);
    if (t) return t;
    if (Cu) {
      let u = Cu(e).toString();
      return this.memoizedFileURLs.set(e, u), u;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let t = this.memoizedURLs.get(e);
    if (t) return t;
    jr === "\\" && (e = e.replace(/\\/g, "/"));
    let u = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, u), u;
  }
};
var Hr = mn;
const Ot = 39, Du = 34, Xe = 92, Pu = 47, Qe = 10, Ne = 32, Je = 12, Ze = 9, Ye = 13, gn = 91, yn = 93, xn = 40, vn = 41, wn = 123, Sn = 125, En = 59, Tn = 42, An = 58, On = 64, Ke = /[\t\n\f\r "#'()/;[\\\]{}]/g, et = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, Nn = /.[\r\n"'(/\\]/, Lu = /[\da-f]/i;
var _n = function(e, t = {}) {
  let u = e.css.valueOf(), i = t.ignoreErrors, n, o, l, a, f, d, y, s, c, w, E = u.length, b = 0, S = [], N = [];
  function D() {
    return b;
  }
  function I(H) {
    throw e.error("Unclosed " + H, b);
  }
  function R() {
    return N.length === 0 && b >= E;
  }
  function $(H) {
    if (N.length) return N.pop();
    if (b >= E) return;
    let F = H ? H.ignoreUnclosed : !1;
    switch (n = u.charCodeAt(b), n) {
      case Qe:
      case Ne:
      case Ze:
      case Ye:
      case Je: {
        a = b;
        do
          a += 1, n = u.charCodeAt(a);
        while (n === Ne || n === Qe || n === Ze || n === Ye || n === Je);
        d = ["space", u.slice(b, a)], b = a - 1;
        break;
      }
      case gn:
      case yn:
      case wn:
      case Sn:
      case An:
      case En:
      case vn: {
        let V = String.fromCharCode(n);
        d = [V, V, b];
        break;
      }
      case xn: {
        if (w = S.length ? S.pop()[1] : "", c = u.charCodeAt(b + 1), w === "url" && c !== Ot && c !== Du && c !== Ne && c !== Qe && c !== Ze && c !== Je && c !== Ye) {
          a = b;
          do {
            if (y = !1, a = u.indexOf(")", a + 1), a === -1)
              if (i || F) {
                a = b;
                break;
              } else
                I("bracket");
            for (s = a; u.charCodeAt(s - 1) === Xe; )
              s -= 1, y = !y;
          } while (y);
          d = ["brackets", u.slice(b, a + 1), b, a], b = a;
        } else
          a = u.indexOf(")", b + 1), o = u.slice(b, a + 1), a === -1 || Nn.test(o) ? d = ["(", "(", b] : (d = ["brackets", o, b, a], b = a);
        break;
      }
      case Ot:
      case Du: {
        f = n === Ot ? "'" : '"', a = b;
        do {
          if (y = !1, a = u.indexOf(f, a + 1), a === -1)
            if (i || F) {
              a = b + 1;
              break;
            } else
              I("string");
          for (s = a; u.charCodeAt(s - 1) === Xe; )
            s -= 1, y = !y;
        } while (y);
        d = ["string", u.slice(b, a + 1), b, a], b = a;
        break;
      }
      case On: {
        Ke.lastIndex = b + 1, Ke.test(u), Ke.lastIndex === 0 ? a = u.length - 1 : a = Ke.lastIndex - 2, d = ["at-word", u.slice(b, a + 1), b, a], b = a;
        break;
      }
      case Xe: {
        for (a = b, l = !0; u.charCodeAt(a + 1) === Xe; )
          a += 1, l = !l;
        if (n = u.charCodeAt(a + 1), l && n !== Pu && n !== Ne && n !== Qe && n !== Ze && n !== Ye && n !== Je && (a += 1, Lu.test(u.charAt(a)))) {
          for (; Lu.test(u.charAt(a + 1)); )
            a += 1;
          u.charCodeAt(a + 1) === Ne && (a += 1);
        }
        d = ["word", u.slice(b, a + 1), b, a], b = a;
        break;
      }
      default: {
        n === Pu && u.charCodeAt(b + 1) === Tn ? (a = u.indexOf("*/", b + 2) + 1, a === 0 && (i || F ? a = u.length : I("comment")), d = ["comment", u.slice(b, a + 1), b, a], b = a) : (et.lastIndex = b + 1, et.test(u), et.lastIndex === 0 ? a = u.length - 1 : a = et.lastIndex - 2, d = ["word", u.slice(b, a + 1), b, a], S.push(d), b = a);
        break;
      }
    }
    return b++, d;
  }
  function W(H) {
    N.push(H);
  }
  return {
    back: W,
    endOfFile: R,
    nextToken: $,
    position: D
  };
};
let In = nu, Cn = yt, Dn = xt, Pn = Ve, Mu = su, Ln = _n;
const Ru = {
  empty: !0,
  space: !0
};
function Mn(r) {
  for (let e = r.length - 1; e >= 0; e--) {
    let t = r[e], u = t[3] || t[2];
    if (u) return u;
  }
}
let Rn = class {
  constructor(e) {
    this.input = e, this.root = new Pn(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let t = new In();
    t.name = e[1].slice(1), t.name === "" && this.unnamedAtrule(t, e), this.init(t, e[2]);
    let u, i, n, o = !1, l = !1, a = [], f = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), u = e[0], u === "(" || u === "[" ? f.push(u === "(" ? ")" : "]") : u === "{" && f.length > 0 ? f.push("}") : u === f[f.length - 1] && f.pop(), f.length === 0)
        if (u === ";") {
          t.source.end = this.getPosition(e[2]), t.source.end.offset++, this.semicolon = !0;
          break;
        } else if (u === "{") {
          l = !0;
          break;
        } else if (u === "}") {
          if (a.length > 0) {
            for (n = a.length - 1, i = a[n]; i && i[0] === "space"; )
              i = a[--n];
            i && (t.source.end = this.getPosition(i[3] || i[2]), t.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          a.push(e);
      else
        a.push(e);
      if (this.tokenizer.endOfFile()) {
        o = !0;
        break;
      }
    }
    t.raws.between = this.spacesAndCommentsFromEnd(a), a.length ? (t.raws.afterName = this.spacesAndCommentsFromStart(a), this.raw(t, "params", a), o && (e = a[a.length - 1], t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++, this.spaces = t.raws.between, t.raws.between = "")) : (t.raws.afterName = "", t.params = ""), l && (t.nodes = [], this.current = t);
  }
  checkMissedSemicolon(e) {
    let t = this.colon(e);
    if (t === !1) return;
    let u = 0, i;
    for (let n = t - 1; n >= 0 && (i = e[n], !(i[0] !== "space" && (u += 1, u === 2))); n--)
      ;
    throw this.input.error(
      "Missed semicolon",
      i[0] === "word" ? i[3] + 1 : i[2]
    );
  }
  colon(e) {
    let t = 0, u, i, n;
    for (let [o, l] of e.entries()) {
      if (i = l, n = i[0], n === "(" && (t += 1), n === ")" && (t -= 1), t === 0 && n === ":")
        if (!u)
          this.doubleColon(i);
        else {
          if (u[0] === "word" && u[1] === "progid")
            continue;
          return o;
        }
      u = i;
    }
    return !1;
  }
  comment(e) {
    let t = new Cn();
    this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
    let u = e[1].slice(2, -2);
    if (/^\s*$/.test(u))
      t.text = "", t.raws.left = u, t.raws.right = "";
    else {
      let i = u.match(/^(\s*)([^]*\S)(\s*)$/);
      t.text = i[2], t.raws.left = i[1], t.raws.right = i[3];
    }
  }
  createTokenizer() {
    this.tokenizer = Ln(this.input);
  }
  decl(e, t) {
    let u = new Dn();
    this.init(u, e[0][2]);
    let i = e[e.length - 1];
    for (i[0] === ";" && (this.semicolon = !0, e.pop()), u.source.end = this.getPosition(
      i[3] || i[2] || Mn(e)
    ), u.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), u.raws.before += e.shift()[1];
    for (u.source.start = this.getPosition(e[0][2]), u.prop = ""; e.length; ) {
      let f = e[0][0];
      if (f === ":" || f === "space" || f === "comment")
        break;
      u.prop += e.shift()[1];
    }
    u.raws.between = "";
    let n;
    for (; e.length; )
      if (n = e.shift(), n[0] === ":") {
        u.raws.between += n[1];
        break;
      } else
        n[0] === "word" && /\w/.test(n[1]) && this.unknownWord([n]), u.raws.between += n[1];
    (u.prop[0] === "_" || u.prop[0] === "*") && (u.raws.before += u.prop[0], u.prop = u.prop.slice(1));
    let o = [], l;
    for (; e.length && (l = e[0][0], !(l !== "space" && l !== "comment")); )
      o.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let f = e.length - 1; f >= 0; f--) {
      if (n = e[f], n[1].toLowerCase() === "!important") {
        u.important = !0;
        let d = this.stringFrom(e, f);
        d = this.spacesFromEnd(e) + d, d !== " !important" && (u.raws.important = d);
        break;
      } else if (n[1].toLowerCase() === "important") {
        let d = e.slice(0), y = "";
        for (let s = f; s > 0; s--) {
          let c = d[s][0];
          if (y.trim().startsWith("!") && c !== "space")
            break;
          y = d.pop()[1] + y;
        }
        y.trim().startsWith("!") && (u.important = !0, u.raws.important = y, e = d);
      }
      if (n[0] !== "space" && n[0] !== "comment")
        break;
    }
    e.some((f) => f[0] !== "space" && f[0] !== "comment") && (u.raws.between += o.map((f) => f[1]).join(""), o = []), this.raw(u, "value", o.concat(e), t), u.value.includes(":") && !t && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let t = new Mu();
    this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let t = this.current.nodes[this.current.nodes.length - 1];
      t && t.type === "rule" && !t.raws.ownSemicolon && (t.raws.ownSemicolon = this.spaces, this.spaces = "", t.source.end = this.getPosition(e[2]), t.source.end.offset += t.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(e) {
    let t = this.input.fromOffset(e);
    return {
      column: t.col,
      line: t.line,
      offset: e
    };
  }
  init(e, t) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(t)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let t = !1, u = null, i = !1, n = null, o = [], l = e[1].startsWith("--"), a = [], f = e;
    for (; f; ) {
      if (u = f[0], a.push(f), u === "(" || u === "[")
        n || (n = f), o.push(u === "(" ? ")" : "]");
      else if (l && i && u === "{")
        n || (n = f), o.push("}");
      else if (o.length === 0)
        if (u === ";")
          if (i) {
            this.decl(a, l);
            return;
          } else
            break;
        else if (u === "{") {
          this.rule(a);
          return;
        } else if (u === "}") {
          this.tokenizer.back(a.pop()), t = !0;
          break;
        } else u === ":" && (i = !0);
      else u === o[o.length - 1] && (o.pop(), o.length === 0 && (n = null));
      f = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (t = !0), o.length > 0 && this.unclosedBracket(n), t && i) {
      if (!l)
        for (; a.length && (f = a[a.length - 1][0], !(f !== "space" && f !== "comment")); )
          this.tokenizer.back(a.pop());
      this.decl(a, l);
    } else
      this.unknownWord(a);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, t, u, i) {
    let n, o, l = u.length, a = "", f = !0, d, y;
    for (let s = 0; s < l; s += 1)
      n = u[s], o = n[0], o === "space" && s === l - 1 && !i ? f = !1 : o === "comment" ? (y = u[s - 1] ? u[s - 1][0] : "empty", d = u[s + 1] ? u[s + 1][0] : "empty", !Ru[y] && !Ru[d] ? a.slice(-1) === "," ? f = !1 : a += n[1] : f = !1) : a += n[1];
    if (!f) {
      let s = u.reduce((c, w) => c + w[1], "");
      e.raws[t] = { raw: s, value: a };
    }
    e[t] = a;
  }
  rule(e) {
    e.pop();
    let t = new Mu();
    this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
  }
  spacesAndCommentsFromEnd(e) {
    let t, u = "";
    for (; e.length && (t = e[e.length - 1][0], !(t !== "space" && t !== "comment")); )
      u = e.pop()[1] + u;
    return u;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let t, u = "";
    for (; e.length && (t = e[0][0], !(t !== "space" && t !== "comment")); )
      u += e.shift()[1];
    return u;
  }
  spacesFromEnd(e) {
    let t, u = "";
    for (; e.length && (t = e[e.length - 1][0], t === "space"); )
      u = e.pop()[1] + u;
    return u;
  }
  stringFrom(e, t) {
    let u = "";
    for (let i = t; i < e.length; i++)
      u += e[i][1];
    return e.splice(t, e.length - t), u;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word " + e[0][1],
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, t) {
    throw this.input.error(
      "At-rule without name",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
};
var kn = Rn;
let qn = me, Bn = vt, jn = kn;
function dt(r, e) {
  let t = new Bn(r, e), u = new jn(t);
  try {
    u.parse();
  } catch (i) {
    throw process.env.NODE_ENV !== "production" && i.name === "CssSyntaxError" && e && e.from && (/\.scss$/i.test(e.from) ? i.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(e.from) ? i.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(e.from) && (i.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), i;
  }
  return u.root;
}
var ou = dt;
dt.default = dt;
qn.registerParse(dt);
let Ut = class {
  constructor(e, t = {}) {
    if (this.type = "warning", this.text = e, t.node && t.node.source) {
      let u = t.node.rangeBy(t);
      this.line = u.start.line, this.column = u.start.column, this.endLine = u.end.line, this.endColumn = u.end.column;
    }
    for (let u in t) this[u] = t[u];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var $r = Ut;
Ut.default = Ut;
let Un = $r, Ht = class {
  get content() {
    return this.css;
  }
  constructor(e, t, u) {
    this.processor = e, this.messages = [], this.root = t, this.opts = u, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, t = {}) {
    t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
    let u = new Un(e, t);
    return this.messages.push(u), u;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
};
var cu = Ht;
Ht.default = Ht;
let ku = {};
var Fr = function(e) {
  ku[e] || (ku[e] = !0, typeof console < "u" && console.warn && console.warn(e));
};
let Hn = me, $n = au, Fn = Hr, Vn = ou, qu = cu, zn = Ve, Gn = mt, { isClean: Z, my: Wn } = Fe, Xn = Fr;
const Qn = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, Jn = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, Zn = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, Se = 0;
function _e(r) {
  return typeof r == "object" && typeof r.then == "function";
}
function Vr(r) {
  let e = !1, t = Qn[r.type];
  return r.type === "decl" ? e = r.prop.toLowerCase() : r.type === "atrule" && (e = r.name.toLowerCase()), e && r.append ? [
    t,
    t + "-" + e,
    Se,
    t + "Exit",
    t + "Exit-" + e
  ] : e ? [t, t + "-" + e, t + "Exit", t + "Exit-" + e] : r.append ? [t, Se, t + "Exit"] : [t, t + "Exit"];
}
function Bu(r) {
  let e;
  return r.type === "document" ? e = ["Document", Se, "DocumentExit"] : r.type === "root" ? e = ["Root", Se, "RootExit"] : e = Vr(r), {
    eventIndex: 0,
    events: e,
    iterator: 0,
    node: r,
    visitorIndex: 0,
    visitors: []
  };
}
function $t(r) {
  return r[Z] = !1, r.nodes && r.nodes.forEach((e) => $t(e)), r;
}
let Ft = {}, Ee = class zr {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(e, t, u) {
    this.stringified = !1, this.processed = !1;
    let i;
    if (typeof t == "object" && t !== null && (t.type === "root" || t.type === "document"))
      i = $t(t);
    else if (t instanceof zr || t instanceof qu)
      i = $t(t.root), t.map && (typeof u.map > "u" && (u.map = {}), u.map.inline || (u.map.inline = !1), u.map.prev = t.map);
    else {
      let n = Vn;
      u.syntax && (n = u.syntax.parse), u.parser && (n = u.parser), n.parse && (n = n.parse);
      try {
        i = n(t, u);
      } catch (o) {
        this.processed = !0, this.error = o;
      }
      i && !i[Wn] && Hn.rebuild(i);
    }
    this.result = new qu(e, i, u), this.helpers = { ...Ft, postcss: Ft, result: this.result }, this.plugins = this.processor.plugins.map((n) => typeof n == "object" && n.prepare ? { ...n, ...n.prepare(this.result) } : n);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(e, t) {
    let u = this.result.lastPlugin;
    try {
      if (t && t.addToError(e), this.error = e, e.name === "CssSyntaxError" && !e.plugin)
        e.plugin = u.postcssPlugin, e.setMessage();
      else if (u.postcssVersion && process.env.NODE_ENV !== "production") {
        let i = u.postcssPlugin, n = u.postcssVersion, o = this.result.processor.version, l = n.split("."), a = o.split(".");
        (l[0] !== a[0] || parseInt(l[1]) > parseInt(a[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + o + ", but " + i + " uses " + n + ". Perhaps this is the source of the error below."
        );
      }
    } catch (i) {
      console && console.error && console.error(i);
    }
    return e;
  }
  prepareVisitors() {
    this.listeners = {};
    let e = (t, u, i) => {
      this.listeners[u] || (this.listeners[u] = []), this.listeners[u].push([t, i]);
    };
    for (let t of this.plugins)
      if (typeof t == "object")
        for (let u in t) {
          if (!Jn[u] && /^[A-Z]/.test(u))
            throw new Error(
              `Unknown event ${u} in ${t.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!Zn[u])
            if (typeof t[u] == "object")
              for (let i in t[u])
                i === "*" ? e(t, u, t[u][i]) : e(
                  t,
                  u + "-" + i.toLowerCase(),
                  t[u][i]
                );
            else typeof t[u] == "function" && e(t, u, t[u]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let e = 0; e < this.plugins.length; e++) {
      let t = this.plugins[e], u = this.runOnRoot(t);
      if (_e(u))
        try {
          await u;
        } catch (i) {
          throw this.handleError(i);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[Z]; ) {
        e[Z] = !0;
        let t = [Bu(e)];
        for (; t.length > 0; ) {
          let u = this.visitTick(t);
          if (_e(u))
            try {
              await u;
            } catch (i) {
              let n = t[t.length - 1].node;
              throw this.handleError(i, n);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [t, u] of this.listeners.OnceExit) {
          this.result.lastPlugin = t;
          try {
            if (e.type === "document") {
              let i = e.nodes.map(
                (n) => u(n, this.helpers)
              );
              await Promise.all(i);
            } else
              await u(e, this.helpers);
          } catch (i) {
            throw this.handleError(i);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(e) {
    this.result.lastPlugin = e;
    try {
      if (typeof e == "object" && e.Once) {
        if (this.result.root.type === "document") {
          let t = this.result.root.nodes.map(
            (u) => e.Once(u, this.helpers)
          );
          return _e(t[0]) ? Promise.all(t) : t;
        }
        return e.Once(this.result.root, this.helpers);
      } else if (typeof e == "function")
        return e(this.result.root, this.result);
    } catch (t) {
      throw this.handleError(t);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let e = this.result.opts, t = Gn;
    e.syntax && (t = e.syntax.stringify), e.stringifier && (t = e.stringifier), t.stringify && (t = t.stringify);
    let i = new Fn(t, this.result.root, this.result.opts).generate();
    return this.result.css = i[0], this.result.map = i[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let e of this.plugins) {
      let t = this.runOnRoot(e);
      if (_e(t))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[Z]; )
        e[Z] = !0, this.walkSync(e);
      if (this.listeners.OnceExit)
        if (e.type === "document")
          for (let t of e.nodes)
            this.visitSync(this.listeners.OnceExit, t);
        else
          this.visitSync(this.listeners.OnceExit, e);
    }
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || Xn(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this.css;
  }
  visitSync(e, t) {
    for (let [u, i] of e) {
      this.result.lastPlugin = u;
      let n;
      try {
        n = i(t, this.helpers);
      } catch (o) {
        throw this.handleError(o, t.proxyOf);
      }
      if (t.type !== "root" && t.type !== "document" && !t.parent)
        return !0;
      if (_e(n))
        throw this.getAsyncError();
    }
  }
  visitTick(e) {
    let t = e[e.length - 1], { node: u, visitors: i } = t;
    if (u.type !== "root" && u.type !== "document" && !u.parent) {
      e.pop();
      return;
    }
    if (i.length > 0 && t.visitorIndex < i.length) {
      let [o, l] = i[t.visitorIndex];
      t.visitorIndex += 1, t.visitorIndex === i.length && (t.visitors = [], t.visitorIndex = 0), this.result.lastPlugin = o;
      try {
        return l(u.toProxy(), this.helpers);
      } catch (a) {
        throw this.handleError(a, u);
      }
    }
    if (t.iterator !== 0) {
      let o = t.iterator, l;
      for (; l = u.nodes[u.indexes[o]]; )
        if (u.indexes[o] += 1, !l[Z]) {
          l[Z] = !0, e.push(Bu(l));
          return;
        }
      t.iterator = 0, delete u.indexes[o];
    }
    let n = t.events;
    for (; t.eventIndex < n.length; ) {
      let o = n[t.eventIndex];
      if (t.eventIndex += 1, o === Se) {
        u.nodes && u.nodes.length && (u[Z] = !0, t.iterator = u.getIterator());
        return;
      } else if (this.listeners[o]) {
        t.visitors = this.listeners[o];
        return;
      }
    }
    e.pop();
  }
  walkSync(e) {
    e[Z] = !0;
    let t = Vr(e);
    for (let u of t)
      if (u === Se)
        e.nodes && e.each((i) => {
          i[Z] || this.walkSync(i);
        });
      else {
        let i = this.listeners[u];
        if (i && this.visitSync(i, e.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
Ee.registerPostcss = (r) => {
  Ft = r;
};
var Gr = Ee;
Ee.default = Ee;
zn.registerLazyResult(Ee);
$n.registerLazyResult(Ee);
let Yn = Hr, Kn = ou;
const ea = cu;
let ta = mt, ua = Fr, Vt = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, t = Kn;
    try {
      e = t(this._css, this._opts);
    } catch (u) {
      this.error = u;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(e, t, u) {
    t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = u, this._map = void 0;
    let i, n = ta;
    this.result = new ea(this._processor, i, this._opts), this.result.css = t;
    let o = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return o.root;
      }
    });
    let l = new Yn(n, i, this._opts, t);
    if (l.isMap()) {
      let [a, f] = l.generate();
      a && (this.result.css = a), f && (this.result.map = f);
    } else
      l.clearAnnotation(), this.result.css = l.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || ua(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var ra = Vt;
Vt.default = Vt;
let ia = au, na = Gr, aa = ra, sa = Ve, qe = class {
  constructor(e = []) {
    this.version = "8.5.3", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let t = [];
    for (let u of e)
      if (u.postcss === !0 ? u = u() : u.postcss && (u = u.postcss), typeof u == "object" && Array.isArray(u.plugins))
        t = t.concat(u.plugins);
      else if (typeof u == "object" && u.postcssPlugin)
        t.push(u);
      else if (typeof u == "function")
        t.push(u);
      else if (typeof u == "object" && (u.parse || u.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(u + " is not a PostCSS plugin");
    return t;
  }
  process(e, t = {}) {
    return !this.plugins.length && !t.parser && !t.stringifier && !t.syntax ? new aa(this, e, t) : new na(this, e, t);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var oa = qe;
qe.default = qe;
sa.registerProcessor(qe);
ia.registerProcessor(qe);
let Wr = nu, Xr = yt, ca = me, la = uu, Qr = xt, Jr = au, fa = dn, da = vt, ha = Gr, pa = Rr, ba = gt, ma = ou, lu = oa, ga = cu, Zr = Ve, Yr = su, ya = mt, xa = $r;
function M(...r) {
  return r.length === 1 && Array.isArray(r[0]) && (r = r[0]), new lu(r);
}
M.plugin = function(e, t) {
  let u = !1;
  function i(...o) {
    console && console.warn && !u && (u = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let l = t(...o);
    return l.postcssPlugin = e, l.postcssVersion = new lu().version, l;
  }
  let n;
  return Object.defineProperty(i, "postcss", {
    get() {
      return n || (n = i()), n;
    }
  }), i.process = function(o, l, a) {
    return M([i(a)]).process(o, l);
  }, i;
};
M.stringify = ya;
M.parse = ma;
M.fromJSON = fa;
M.list = pa;
M.comment = (r) => new Xr(r);
M.atRule = (r) => new Wr(r);
M.decl = (r) => new Qr(r);
M.rule = (r) => new Yr(r);
M.root = (r) => new Zr(r);
M.document = (r) => new Jr(r);
M.CssSyntaxError = la;
M.Declaration = Qr;
M.Container = ca;
M.Processor = lu;
M.Document = Jr;
M.Comment = Xr;
M.Warning = xa;
M.AtRule = Wr;
M.Result = ga;
M.Input = da;
M.Rule = Yr;
M.Root = Zr;
M.Node = ba;
ha.registerPostcss(M);
var va = M;
M.default = M;
const wa = $u, ju = b0, { isPlainObject: Sa } = eu, Uu = C0, Ea = D0, { parse: Ta } = va, Aa = [
  "img",
  "audio",
  "video",
  "picture",
  "svg",
  "object",
  "map",
  "iframe",
  "embed"
], Oa = ["script", "style"];
function Ie(r, e) {
  r && Object.keys(r).forEach(function(t) {
    e(r[t], t);
  });
}
function ue(r, e) {
  return {}.hasOwnProperty.call(r, e);
}
function Hu(r, e) {
  const t = [];
  return Ie(r, function(u) {
    e(u) && t.push(u);
  }), t;
}
function Na(r) {
  for (const e in r)
    if (ue(r, e))
      return !1;
  return !0;
}
function _a(r) {
  return r.map(function(e) {
    if (!e.url)
      throw new Error("URL missing");
    return e.url + (e.w ? ` ${e.w}w` : "") + (e.h ? ` ${e.h}h` : "") + (e.d ? ` ${e.d}x` : "");
  }).join(", ");
}
var Ia = Be;
const Ca = /^[^\0\t\n\f\r /<=>]+$/;
function Be(r, e, t) {
  if (r == null)
    return "";
  typeof r == "number" && (r = r.toString());
  let u = "", i = "";
  function n(h, g) {
    const m = this;
    this.tag = h, this.attribs = g || {}, this.tagPosition = u.length, this.text = "", this.mediaChildren = [], this.updateParentNodeText = function() {
      if (b.length) {
        const T = b[b.length - 1];
        T.text += m.text;
      }
    }, this.updateParentNodeMediaChildren = function() {
      b.length && Aa.includes(this.tag) && b[b.length - 1].mediaChildren.push(this.tag);
    };
  }
  e = Object.assign({}, Be.defaults, e), e.parser = Object.assign({}, Da, e.parser);
  const o = function(h) {
    return e.allowedTags === !1 || (e.allowedTags || []).indexOf(h) > -1;
  };
  Oa.forEach(function(h) {
    o(h) && !e.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${h}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
  });
  const l = e.nonTextTags || [
    "script",
    "style",
    "textarea",
    "option"
  ];
  let a, f;
  e.allowedAttributes && (a = {}, f = {}, Ie(e.allowedAttributes, function(h, g) {
    a[g] = [];
    const m = [];
    h.forEach(function(T) {
      typeof T == "string" && T.indexOf("*") >= 0 ? m.push(ju(T).replace(/\\\*/g, ".*")) : a[g].push(T);
    }), m.length && (f[g] = new RegExp("^(" + m.join("|") + ")$"));
  }));
  const d = {}, y = {}, s = {};
  Ie(e.allowedClasses, function(h, g) {
    if (a && (ue(a, g) || (a[g] = []), a[g].push("class")), d[g] = h, Array.isArray(h)) {
      const m = [];
      d[g] = [], s[g] = [], h.forEach(function(T) {
        typeof T == "string" && T.indexOf("*") >= 0 ? m.push(ju(T).replace(/\\\*/g, ".*")) : T instanceof RegExp ? s[g].push(T) : d[g].push(T);
      }), m.length && (y[g] = new RegExp("^(" + m.join("|") + ")$"));
    }
  });
  const c = {};
  let w;
  Ie(e.transformTags, function(h, g) {
    let m;
    typeof h == "function" ? m = h : typeof h == "string" && (m = Be.simpleTransform(h)), g === "*" ? w = m : c[g] = m;
  });
  let E, b, S, N, D, I, R = !1;
  W();
  const $ = new wa.Parser({
    onopentag: function(h, g) {
      if (e.enforceHtmlBoundary && h === "html" && W(), D) {
        I++;
        return;
      }
      const m = new n(h, g);
      b.push(m);
      let T = !1;
      const j = !!m.text;
      let U;
      if (ue(c, h) && (U = c[h](h, g), m.attribs = g = U.attribs, U.text !== void 0 && (m.innerText = U.text), h !== U.tagName && (m.name = h = U.tagName, N[E] = U.tagName)), w && (U = w(h, g), m.attribs = g = U.attribs, h !== U.tagName && (m.name = h = U.tagName, N[E] = U.tagName)), (!o(h) || e.disallowedTagsMode === "recursiveEscape" && !Na(S) || e.nestingLimit != null && E >= e.nestingLimit) && (T = !0, S[E] = !0, (e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") && l.indexOf(h) !== -1 && (D = !0, I = 1), S[E] = !0), E++, T) {
        if (e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") {
          if (m.innerText && !j) {
            const k = H(m.innerText);
            e.textFilter ? u += e.textFilter(k, h) : u += H(m.innerText), R = !0;
          }
          return;
        }
        i = u, u = "";
      }
      u += "<" + h, h === "script" && (e.allowedScriptHostnames || e.allowedScriptDomains) && (m.innerText = ""), (!a || ue(a, h) || a["*"]) && Ie(g, function(k, q) {
        if (!Ca.test(q)) {
          delete m.attribs[q];
          return;
        }
        if (k === "" && !e.allowedEmptyAttributes.includes(q) && (e.nonBooleanAttributes.includes(q) || e.nonBooleanAttributes.includes("*"))) {
          delete m.attribs[q];
          return;
        }
        let wt = !1;
        if (!a || ue(a, h) && a[h].indexOf(q) !== -1 || a["*"] && a["*"].indexOf(q) !== -1 || ue(f, h) && f[h].test(q) || f["*"] && f["*"].test(q))
          wt = !0;
        else if (a && a[h]) {
          for (const P of a[h])
            if (Sa(P) && P.name && P.name === q) {
              wt = !0;
              let L = "";
              if (P.multiple === !0) {
                const fe = k.split(" ");
                for (const ee of fe)
                  P.values.indexOf(ee) !== -1 && (L === "" ? L = ee : L += " " + ee);
              } else P.values.indexOf(k) >= 0 && (L = k);
              k = L;
            }
        }
        if (wt) {
          if (e.allowedSchemesAppliedToAttributes.indexOf(q) !== -1 && F(h, k)) {
            delete m.attribs[q];
            return;
          }
          if (h === "script" && q === "src") {
            let P = !0;
            try {
              const L = V(k);
              if (e.allowedScriptHostnames || e.allowedScriptDomains) {
                const fe = (e.allowedScriptHostnames || []).find(function(X) {
                  return X === L.url.hostname;
                }), ee = (e.allowedScriptDomains || []).find(function(X) {
                  return L.url.hostname === X || L.url.hostname.endsWith(`.${X}`);
                });
                P = fe || ee;
              }
            } catch {
              P = !1;
            }
            if (!P) {
              delete m.attribs[q];
              return;
            }
          }
          if (h === "iframe" && q === "src") {
            let P = !0;
            try {
              const L = V(k);
              if (L.isRelativeUrl)
                P = ue(e, "allowIframeRelativeUrls") ? e.allowIframeRelativeUrls : !e.allowedIframeHostnames && !e.allowedIframeDomains;
              else if (e.allowedIframeHostnames || e.allowedIframeDomains) {
                const fe = (e.allowedIframeHostnames || []).find(function(X) {
                  return X === L.url.hostname;
                }), ee = (e.allowedIframeDomains || []).find(function(X) {
                  return L.url.hostname === X || L.url.hostname.endsWith(`.${X}`);
                });
                P = fe || ee;
              }
            } catch {
              P = !1;
            }
            if (!P) {
              delete m.attribs[q];
              return;
            }
          }
          if (q === "srcset")
            try {
              let P = Ea(k);
              if (P.forEach(function(L) {
                F("srcset", L.url) && (L.evil = !0);
              }), P = Hu(P, function(L) {
                return !L.evil;
              }), P.length)
                k = _a(Hu(P, function(L) {
                  return !L.evil;
                })), m.attribs[q] = k;
              else {
                delete m.attribs[q];
                return;
              }
            } catch {
              delete m.attribs[q];
              return;
            }
          if (q === "class") {
            const P = d[h], L = d["*"], fe = y[h], ee = s[h], X = s["*"], Kr = y["*"], fu = [
              fe,
              Kr
            ].concat(ee, X).filter(function(ei) {
              return ei;
            });
            if (P && L ? k = A(k, Uu(P, L), fu) : k = A(k, P || L, fu), !k.length) {
              delete m.attribs[q];
              return;
            }
          }
          if (q === "style") {
            if (e.parseStyleAttributes)
              try {
                const P = Ta(h + " {" + k + "}", { map: !1 }), L = p(P, e.allowedStyles);
                if (k = x(L), k.length === 0) {
                  delete m.attribs[q];
                  return;
                }
              } catch {
                typeof window < "u" && console.warn('Failed to parse "' + h + " {" + k + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete m.attribs[q];
                return;
              }
            else if (e.allowedStyles)
              throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
          }
          u += " " + q, k && k.length ? u += '="' + H(k, !0) + '"' : e.allowedEmptyAttributes.includes(q) && (u += '=""');
        } else
          delete m.attribs[q];
      }), e.selfClosing.indexOf(h) !== -1 ? u += " />" : (u += ">", m.innerText && !j && !e.textFilter && (u += H(m.innerText), R = !0)), T && (u = i + H(u), i = "");
    },
    ontext: function(h) {
      if (D)
        return;
      const g = b[b.length - 1];
      let m;
      if (g && (m = g.tag, h = g.innerText !== void 0 ? g.innerText : h), e.disallowedTagsMode === "completelyDiscard" && !o(m))
        h = "";
      else if ((e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") && (m === "script" || m === "style"))
        u += h;
      else {
        const T = H(h, !1);
        e.textFilter && !R ? u += e.textFilter(T, m) : R || (u += T);
      }
      if (b.length) {
        const T = b[b.length - 1];
        T.text += h;
      }
    },
    onclosetag: function(h, g) {
      if (D)
        if (I--, !I)
          D = !1;
        else
          return;
      const m = b.pop();
      if (!m)
        return;
      if (m.tag !== h) {
        b.push(m);
        return;
      }
      D = e.enforceHtmlBoundary ? h === "html" : !1, E--;
      const T = S[E];
      if (T) {
        if (delete S[E], e.disallowedTagsMode === "discard" || e.disallowedTagsMode === "completelyDiscard") {
          m.updateParentNodeText();
          return;
        }
        i = u, u = "";
      }
      if (N[E] && (h = N[E], delete N[E]), e.exclusiveFilter && e.exclusiveFilter(m)) {
        u = u.substr(0, m.tagPosition);
        return;
      }
      if (m.updateParentNodeMediaChildren(), m.updateParentNodeText(), // Already output />
      e.selfClosing.indexOf(h) !== -1 || // Escaped tag, closing tag is implied
      g && !o(h) && ["escape", "recursiveEscape"].indexOf(e.disallowedTagsMode) >= 0) {
        T && (u = i, i = "");
        return;
      }
      u += "</" + h + ">", T && (u = i + H(u), i = ""), R = !1;
    }
  }, e.parser);
  return $.write(r), $.end(), u;
  function W() {
    u = "", E = 0, b = [], S = {}, N = {}, D = !1, I = 0;
  }
  function H(h, g) {
    return typeof h != "string" && (h = h + ""), e.parser.decodeEntities && (h = h.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), g && (h = h.replace(/"/g, "&quot;"))), h = h.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), g && (h = h.replace(/"/g, "&quot;")), h;
  }
  function F(h, g) {
    for (g = g.replace(/[\x00-\x20]+/g, ""); ; ) {
      const j = g.indexOf("<!--");
      if (j === -1)
        break;
      const U = g.indexOf("-->", j + 4);
      if (U === -1)
        break;
      g = g.substring(0, j) + g.substring(U + 3);
    }
    const m = g.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!m)
      return g.match(/^[/\\]{2}/) ? !e.allowProtocolRelative : !1;
    const T = m[1].toLowerCase();
    return ue(e.allowedSchemesByTag, h) ? e.allowedSchemesByTag[h].indexOf(T) === -1 : !e.allowedSchemes || e.allowedSchemes.indexOf(T) === -1;
  }
  function V(h) {
    if (h = h.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), h.startsWith("relative:"))
      throw new Error("relative: exploit attempt");
    let g = "relative://relative-site";
    for (let j = 0; j < 100; j++)
      g += `/${j}`;
    const m = new URL(h, g);
    return {
      isRelativeUrl: m && m.hostname === "relative-site" && m.protocol === "relative:",
      url: m
    };
  }
  function p(h, g) {
    if (!g)
      return h;
    const m = h.nodes[0];
    let T;
    return g[m.selector] && g["*"] ? T = Uu(
      g[m.selector],
      g["*"]
    ) : T = g[m.selector] || g["*"], T && (h.nodes[0].nodes = m.nodes.reduce(v(T), [])), h;
  }
  function x(h) {
    return h.nodes[0].nodes.reduce(function(g, m) {
      return g.push(
        `${m.prop}:${m.value}${m.important ? " !important" : ""}`
      ), g;
    }, []).join(";");
  }
  function v(h) {
    return function(g, m) {
      return ue(h, m.prop) && h[m.prop].some(function(j) {
        return j.test(m.value);
      }) && g.push(m), g;
    };
  }
  function A(h, g, m) {
    return g ? (h = h.split(/\s+/), h.filter(function(T) {
      return g.indexOf(T) !== -1 || m.some(function(j) {
        return j.test(T);
      });
    }).join(" ")) : h;
  }
}
const Da = {
  decodeEntities: !0
};
Be.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hgroup",
    "main",
    "nav",
    "section",
    // Text content
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "main",
    "ol",
    "p",
    "pre",
    "ul",
    // Inline text semantics
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    // Table content
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
  ],
  // Tags that cannot be boolean
  nonBooleanAttributes: [
    "abbr",
    "accept",
    "accept-charset",
    "accesskey",
    "action",
    "allow",
    "alt",
    "as",
    "autocapitalize",
    "autocomplete",
    "blocking",
    "charset",
    "cite",
    "class",
    "color",
    "cols",
    "colspan",
    "content",
    "contenteditable",
    "coords",
    "crossorigin",
    "data",
    "datetime",
    "decoding",
    "dir",
    "dirname",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "fetchpriority",
    "for",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formtarget",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "http-equiv",
    "id",
    "imagesizes",
    "imagesrcset",
    "inputmode",
    "integrity",
    "is",
    "itemid",
    "itemprop",
    "itemref",
    "itemtype",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "name",
    "nonce",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "referrerpolicy",
    "rel",
    "rows",
    "rowspan",
    "sandbox",
    "scope",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "spellcheck",
    "src",
    "srcdoc",
    "srclang",
    "srcset",
    "start",
    "step",
    "style",
    "tabindex",
    "target",
    "title",
    "translate",
    "type",
    "usemap",
    "value",
    "width",
    "wrap",
    // Event handlers
    "onauxclick",
    "onafterprint",
    "onbeforematch",
    "onbeforeprint",
    "onbeforeunload",
    "onbeforetoggle",
    "onblur",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "onchange",
    "onclick",
    "onclose",
    "oncontextlost",
    "oncontextmenu",
    "oncontextrestored",
    "oncopy",
    "oncuechange",
    "oncut",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onerror",
    "onfocus",
    "onformdata",
    "onhashchange",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onlanguagechange",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmessage",
    "onmessageerror",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onoffline",
    "ononline",
    "onpagehide",
    "onpageshow",
    "onpaste",
    "onpause",
    "onplay",
    "onplaying",
    "onpopstate",
    "onprogress",
    "onratechange",
    "onreset",
    "onresize",
    "onrejectionhandled",
    "onscroll",
    "onscrollend",
    "onsecuritypolicyviolation",
    "onseeked",
    "onseeking",
    "onselect",
    "onslotchange",
    "onstalled",
    "onstorage",
    "onsubmit",
    "onsuspend",
    "ontimeupdate",
    "ontoggle",
    "onunhandledrejection",
    "onunload",
    "onvolumechange",
    "onwaiting",
    "onwheel"
  ],
  disallowedTagsMode: "discard",
  allowedAttributes: {
    a: ["href", "name", "target"],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
  },
  allowedEmptyAttributes: [
    "alt"
  ],
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
  // URL schemes we permit
  allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
  allowProtocolRelative: !0,
  enforceHtmlBoundary: !1,
  parseStyleAttributes: !0
};
Be.simpleTransform = function(r, e, t) {
  return t = t === void 0 ? !0 : t, e = e || {}, function(u, i) {
    let n;
    if (t)
      for (n in e)
        i[n] = e[n];
    else
      i = e;
    return {
      tagName: r,
      attribs: i
    };
  };
};
const Pa = /* @__PURE__ */ si(Ia), La = "_html-output_3s7du_1", Ma = {
  htmlOutput: La
};
function Ra(r) {
  return ui.useMemo(() => ii(r) ? void 0 : Pa(
    r,
    {
      allowedTags: [
        // https://www.semrush.com/blog/html-tags-list
        "p",
        "br",
        "hr",
        "span",
        "div",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "strong",
        "b",
        "i",
        "em",
        "u",
        "li",
        "ul",
        "ol",
        "a",
        "table",
        "thead",
        "tbody",
        "th",
        "tr",
        "td",
        "dd",
        "dt",
        "dl",
        "sub",
        "sup",
        "img",
        "svg",
        "pre",
        "cite",
        "code",
        "q",
        "iframe"
        // some emergencies, like 3972, needed iframe reference to a dashboard
        // 'base', 'canvas', 'video', // can be switched on when need occurs
        // 'area', 'map', 'label', 'meter', // can be switched on when need occurs
        // forbid: 'input', 'textarea', 'button',
      ],
      allowedAttributes: {
        p: ["style"],
        span: ["style"],
        div: ["style"],
        img: ["style", "src", "width", "height", "alt"],
        iframe: ["style", "src", "width", "height", "frameborder"],
        a: ["style", "href", "target", "rel"]
      },
      allowedSchemes: ["http", "https", "data"],
      allowedStyles: {
        "*": {
          "padding-left": [/^\d+px$/],
          "font-size": [/^\d+px$/],
          "text-align": [/.+/]
        },
        iframe: {
          width: [/^\d+px$/],
          height: [/^\d+px$/],
          border: [/.+/]
        }
      },
      transformTags: {
        a: (u, i) => ({
          tagName: u,
          attribs: {
            ...i,
            target: "_blank",
            rel: "noopener noreferrer"
          }
        })
      }
    }
  ), [r]);
}
function ns(r) {
  const {
    className: e,
    value: t,
    ...u
  } = r, i = Ra(t);
  return /* @__PURE__ */ ti(
    "div",
    {
      ...u,
      className: ni(Ma.htmlOutput, e),
      dangerouslySetInnerHTML: ri(i) ? {
        __html: i
      } : void 0
    }
  );
}
export {
  ns as default
};
